export default {
    VIETNAMESE: "Tiếng việt",
    ENGLISH: "English",
    JAPANESE: "日本語",
    KOREAN: "한국어",
    CHINESE: "中文",
    LAO: "ພາສາລາວ",
    KHMER: "ភាសាខ្មែរ", //tiếng campuchia
    SYNC: "同步",
    PLEASE_SELECT_DATE_LESS_6_MONTH: "请选择一个小于或等于6个月的日期范围",
    // #region chainManager
    CHAIN_DASHBOARD_INFO: "链条",
    CHAIN_DASHBOARD: "链条仪表板",
    BOOKING_DASHBOARD: "预定仪表板",
    USE_HOTEL: "使用酒店",
    // #endregion
    // #region alert
    CANCEL_SUCCESS: "更新成功",
    BOOKING_PAID: "已支付",
    BOOKING_CANCELED: "预定无法取消，请检查状态",
    LOCATION_IS_NOT_EXIST: "位置不存在",
    ROOM_AVAILS_INCORRECT: "空房数不能大于声明的总房间数",
    PROMOTION_NULL: "促销不存在",
    CANCLE_FAILE: "取消失败",
    DELETE_FAILE: "删除失败",
    GROUP_USED: "用户组正在使用中",
    TRANSDATE_INCORRECT: "支付日期必须在预定日期和退房日期之间",
    AMOUNT_INCORRECT: "支付金额不正确",
    HAS_NO_DATA: "没有可用数据",
    LOCATION_NOT_EXIST: "位置不存在",
    UPDATE_SUCCESS: "更新成功",
    UPDATE_CUCCESS: "更新成功",
    DELETE_SUCCESS: "删除成功",
    CREATE_SUCCESS: "创建成功",
    REGISTER_SUCCESS: "注册成功",
    UPLOAD_SUCCESS: "上传成功",
    PROMOTIONS_ARE_BEING_USED: "促销正在使用中",
    PROMOTIONS_DO_NOT_BELONG_TO_HOTELS: "促销不属于酒店",
    COUNPON_EXIST: "优惠券存在",
    USER_IS_EXIST: "用户名已存在",
    EMAIL_USER_IS_EXIST: "邮箱已存在",
    EMAIL_HOTEL_IS_EXIST: "邮箱已存在",
    ACCOUNT_IS_TAKEN: "用户名已被占用",
    USER_NAME_OR_EMAIL_IS_EXISTED: "用户名或邮箱已存在",
    CANNOT_FIND_SOURCE: "找不到来源",
    IMAGE_CAPACITY_NOT_BIGGER_THAN: "最大上传图片大小：",
    FILE_CAPACITY_NOT_BIGGER_THAN: "最大上传文件大小：",
    IMAGE_SIZE_NOT_BIGGER_THAN: "照片最小尺寸",
    INVALID_IMAGE_FORMAT: "无效的图片格式",
    INVALID_FILE_FORMAT: "无效的文件格式",
    DELETE_FAIL: "删除失败",
    IMAGE_MAIN_EMPTY: "主图为空",
    ROOM_EMPTY: "房间为空",
    ROOM_IS_SELECTING: "房间正在选择",
    NOT_SELECTED_PROMOTION: "没有选择促销",
    MISSING_FIELD: "请填写完整必要信息",
    CONFIRM_DELETE_PHOTOS: "确认删除照片",
    MAIN_IMAGES_MUST_EXIST: "主图必须存在",
    CONFIRM_DELETE_POLICY: "确认删除政策",
    CONFIRM_DELETE_SALE_PACKAGE: "确认删除此销售房间包",
    CONFIRM_DELETE_PROMOTION_PACKAGE: "确认删除此促销包",
    CONFIRM_DELETE_ROOM: "确认删除房间",
    UPLOAD_EXPIRED: "上传已过期",
    PAYMENT_METHOD_HAS_NOT_SELECTED: "未选择支付方式",
    SETTING_GATEWAY_EMPTY: "网关设置不存在",
    DEPOSIT_COMPARE_PAYMENT: "支付到期日不能大于定金支付期限",
    TIP_MAIN_IMAGE: "酒店头像为第一张照片。拖动照片以更改显示顺序",
    TIP_MAIN_ROOM_IMAGE: "房间头像为第一张照片。拖动照片以更改显示顺序",
    CUSTOMER_PACKAGE_NOT_BIGGER_THAN_ROOM: "套餐的适用客人人数不能大于房间的最大入住人数",
    FIELD_NUMBER_FORMAT: "仅允许数字字符，不允许空格",
    FIELD_POSITIVE_FORMAT: "仅允许正整数，不允许空格",
    FIELD_DISTANCE_FORMAT: "仅允许数字字符和点（.），不允许空格",
    CHAIN_NAME_EMPTY: "链条名称为空",
    USER_IS_NOT_EXIT: "用户不存在",
    USER_IS_NOT_EXIST: "用户不存在",
    HOTEL_WAS_IN_CHAIN: "酒店已经在链条中",
    //#endregion

    DESCRIPTION_INFO: "描述",
    REQUIRED: "*",
    SELECT_ALL: "全选",
    IMAGES: "照片",
    HOTEL_PHOTO: "酒店照片",
    LIBRARY: "图库",
    ADD_NEW: "创建",
    AND: "和",
    BACK: "返回",
    SAVE: "保存",
    EDIT: "编辑",
    DELETE: "删除",
    COPY: "复制",
    POLICY: "政策",
    ALWAYS: "始终",
    IN_PERIOD: "期间",
    GENERAL_SETTING: "常规设置",
    PAYMENT_POLICY: "支付政策",
    CANCELATION_POLICY: "取消政策",
    PAY_GATE: "支付网关",
    AGENT_STOP_CONNECT: "代理商停止连接",
    WARNING_METHOD: "警告方式",
    ALERT_RECEIVING_METHOD: "警告方式",
    SELECT_WARNING_METHOD: "选择警告方式",
    WARNING_QTY_ROOM: "当房间数量达到设定的阈值时通知",
    SETTING_WARNING_ROOM: "当房间数量达到设定的值时发送通知",
    SEND_WARNING_ANY_ROOM: "当任何房型的房间数量达到设定的值且少于设定的值时发送通知",
    SEND_WARNING_ROOM: "当房间数量达到设定的值时发送通知",
    QTY_ROOM_LESS_THAN: "房间数不足",
    HOTEL_WARNING: "警告方式",
    SETTING_AT_LEAST_1_ROOM: "请至少选择一个房型以设置警告阈值。",

    // HOTEL INFOMATION
    REGISTER_INFO: "注册信息",
    EXTENSION: "设施",
    NEARBY_PLACE: "附近地点",
    HOTEL_CHAIN: "酒店链",
    HOTEL_REGISTER_INFO: "酒店注册信息",

    // #region Register information
    HOTEL_CODE: "酒店代码",
    STAR_RATING: "星级",
    HOTEL_LOGO: "酒店标志",
    CONTACT_PHONE: "电话号码",

    HOTEL_TYPE: "酒店类型",
    COUNTRY: "国家",
    CITY: "省/市",
    DISTRICT: "区/公社/特区",
    WARD: "街道",
    HOTEL_NAME: "酒店名称",
    ADDRESS: "地址",
    MAP_LOCATION: "地图位置",
    LONGITUDE: "经度",
    LATITUDE: "纬度",
    //#endregion

    // LEFT MENU
    DASHBOARD: "仪表板",
    MANAGE: "管理",
    BOOK_ROOM: "预定房间",
    ROOM_SALE: "房间销售",
    ROOM_AVAILABLE_AND_PRICE: "库存和价格",
    SALE_AND_PROMOTION_PACKAGES: "销售和促销包",
    SETTING: "设置",
    ACCOUNT_INFO: "账户配置",
    ACCOUNT_SETTING: "个人账户",
    USER_MANAGE: "用户管理",
    CONTRACT: "合同",
    HOTEL_INFOMATION: "酒店配置",
    GENERAL_INFO: "常规设置",
    TYPE_ROOM: "房间类型",
    HOTEL_CONFIG: "配置",
    GALLERY_MANAGER: "照片库",
    TRAVEL_AGENT: "旅行社",
    ACTIVITY_DAIRY: "系统日志",
    ACTIVITY_DIARY_UPDATE_BULK: "日志更新批量",
    ACTIVITY_DIARY_UPDATE_ROOM_AVAIL: "日志更新库存",
    SUPPORT: "支持",
    INSTRUCTION_DOCUMENT: "操作文档",
    INSTRUCTION_DOCUMENT_CONNECT_BE: "网站集成",
    COPYED: "已复制",
    VIEW_DEMO: "查看预订引擎页面",
    HOTLINE: "热线",
    BOOKING_LIST: "预订",
    REQUEST_BOOKING_LIST: "请求预订",
    REVENUE_AND_EXPENDITURE_TRANSACTION: "交易",
    AGENT_LIST: "代理商列表",
    UNLINKED_LIST: "停止工作的代理商",
    PREVIEW_ON_BE: "预订引擎链接",
    PREVIEW_ON_TA: "查看TA页面",
    SALE_CHANNEL: "销售渠道",
    CHANNEL_GROUP: "渠道组",
    // END LEFT MENU

    SUNDAY: "星期日",
    MONDAY: "星期一",
    TUESDAY: "星期二",
    WEDNESDAY: "星期三",
    THURSDAY: "星期四",
    FRIDAY: "星期五",
    SATURDAY: "星期六",

    _DATE_RANGE: {
        SUNDAY: "日",
        MONDAY: "一",
        TUESDAY: "二",
        WEDNESDAY: "三",
        THURSDAY: "四",
        FRIDAY: "五",
        SATURDAY: "六",
        JAN: "一月",
        FEB: "二月",
        MAR: "三月",
        APR: "四月",
        MAY: "五月",
        JUN: "六月",
        JUL: "七月",
        AUG: "八月",
        SEP: "九月",
        OTC: "十月",
        NOV: "十一月",
        DEC: "十二月"
    },

    //#region PAYGATE
    _PAYGATE: {
        PAYMENT_THROUGH: "支付方式",
        PAYMENT_METHOD: "支付方式",
        ONLINE_PAYMENT_GATEWAY: "在线支付网关",
        CONFIGURATION: "配置",
        CONFIG_PAYMENT_GATE: "支付网关配置",
        HOTEL: "酒店",
        TRANSFER_PAYMENT: "转账支付",
        ONLINE_PAYMENT: "在线支付",
        PAYMENT_TYPE_EMPTY: "不存在支付类型",
        PAYMENT_METHOD_HAS_NOT_SELECTED: "未选择支付方式",
        PAYMENT_GATEWAY_IS_NOT_EXIST: "未选择在线支付网关",
        CASH: "现金支付",
        DEBT: "债务结算",
        PAYMENT_CARD: "支付卡"
    },
    //#region nearby place
    NEAREST_POPULAR_LOCATION: "最近的热门地点",
    MOST_POPULAR_LOCATION: "最受欢迎的地点",
    RESTAURANT_AND_MARKET: "餐厅和市场",
    TRAVEL_PLACE: "旅游景点",
    NEAREST_AIRPORT: "最近的机场",
    VIETNAMESE_NAME: "越南语名称",
    ENGLISH_NAME: "英语名称",
    ADD_LOCATION: "添加位置",
    DISTANCE: "距离",
    //#endregion

    //#region room information
    ROOM_INFOMATION: "房间信息",
    ROOM_AMENITIES: "房间设施",
    ROOM_IMAGE: "房间照片",
    ROOM_NAME: "房间类型",
    ROOM_TYPE: "房间类型",
    MEAL: "餐食",
    NAME_ROOM_TYPE: "房间类型名称",
    NAME_ROOM_TYPE_DEFAULT: "标题（默认）",
    TOTAL_ROOM: "房间数量",
    MAX_CUSTOMER_COUNT: "最大入住人数",
    ROOM_DIMENSION: "房间大小",
    BED_BONUS_COUNT: "额外床位数量",
    PRICE_NORMAL_DAY: "工作日价格",
    PRICE_WEEKEND: "周末价格",
    ROOM_DIRECTION: "房间方向",
    BED_TYPE: "床型",
    ADULT: "成人",
    CHILDREN: "儿童",
    ACTION: "操作",
    COMMON_BED_TYPE: "常见床型",
    COMBINATION_BED_TYPE: "床型组合",
    MORE_OPTIONS: "更多选项",
    REMOVE_OPTIONS: "删除选项",
    ADD_TYPE_BED: "添加床型",
    FREE: "免费",
    SURCHARGE: "附加费",
    //#endregion

    //#region selling room
    PACKAGE: "套餐",
    SELLING_PACKAGE_INFO: "价格计划信息",
    SELLING_PACKAGE: "价格计划",
    SERVICE_PACKAGE: "服务套餐",
    PROMOTION: "促销",
    PROMOTION_INFO: "促销信息",
    NAME_SELLING_PACKAGE: "价格计划名称",
    PACKEAGE_APPLY_FOR: "销售套餐适用对象",
    MEALS_INCLUDE: "包括餐食",
    EXTRA_BED_PRICE: "额外床位价格",
    EXTRA_ADULT_PRICE: "额外成人价格",
    EXTRA_CHILD_PRICE: "额外儿童价格",
    MIN_NIGHT: "最少入住夜数",
    MAX_NIGHT: "最多入住夜数",
    DAYS_NOT_APPLY: "不可用日期",
    NOT_APPLY: "不可用日期",
    ADD_DAYS_NOT_APPLY: "额外不可用日期",
    TYPE_ROOM_APPLIED: "适用房型",
    PLAN_IS_SELECTING: "销售套餐已连接至OTA",
    PLAN_NULL: "价格计划不存在",
    ERROR: "抱歉，发生了意外错误。请稍后再试。",
    COPY_SUCCESS: "复制成功",
    COPPY_SUCCESS: "复制成功",
    NOT_SELECTED_PLAN: "未选择价格计划",
    NOT_SELECTED_ROOM: "未选择房间",
    MAX_STAY_NOT_SMALL_THAN_MIN_STAY: "最大入住夜数不能小于最小入住夜数",
    CBALERT_LB_AVAISEARCH: "请选择一个或多个",

    PROMOTION_PACKAGE_NAME: "促销名称",
    PROMOTION_TYPE: "促销类型",
    APPLY: "应用",
    APPLY_WITH: "与...一起应用",
    DISCOUNT_AND_SURCHARGES: "折扣/附加费率",
    DAYS_APPLY: "适用星期",
    TIME_STAY: "入住日期",
    TIME_SET: "预定日期",
    TARGET_APPLY: "适用对象",
    ARGENT_LEVEL_APPLY: "选择代理商等级",
    ARGENT_APPLY: "选择代理商",
    PACKAGE_APPLY: "价格计划",
    X_DAYS: "x天",
    FROM_DATE: "从",
    TO_DATE: "至",
    MIN_COUNT: "最小数量",
    NIGHT_STAY: "入住夜数",
    ROOM_BOOK_QUANTITY: "预定房间数量",
    QUANTITY_IS_FREE: "免费数量（y）",
    COUPON: "优惠券",
    STATUS: "状态",
    ACTIVE: "激活",
    DEACTIVE: "停用",
    STATE_ACTIVE_OR_DEACTIVE: "激活/停用",
    //#endregion

    //#region booking room
    CONTACT_BOOKING_DETAIL: "联系信息",
    BOOKING_DETAIL: "预订详情",
    NORMAL_ROOM_DETAIL: "基础房间详情",
    VIP_ROOM_DETAIL: "VIP房间详情",
    SERVICES: "服务",
    PAYMENT_HISTORY: "支付历史",
    // #endregion

    // #region common
    FILE_NAME: "文件名",
    FILE_TYPE: "文件类型",
    UPLOAD_BY: "上传者",
    FILE_CAPACITY: "文件容量",
    SIZE: "大小",
    UPLOAD_TIME: "上传时间",
    CLOSE: "关闭",
    TOTAL: "总计",
    OR: "或",
    CHOOSE: "选择",
    NO_PHOTOS_FOUND: "未找到照片",
    // #endregion

    // #region upload controller
    DRAG_DROP_PHOTOS_HERE: "将照片拖放到这里",
    SELECT_PHOTOS_TO_UPLOAD: "选择要上传的照片",
    MAXIMUM_CAPACITY: "最大容量",
    LOADING: "加载中",
    // #endregion

    // #region hotel setting
    EMAIL_CONFIGURATION: "电子邮件设置",
    HOTEL_EMAIL: "酒店电子邮件",
    EMAIL_RECEIVE_BOOKING_ALERT_CC: "通知电子邮件",
    EMAIL_CO_RECEIVE_BOOKING_ALERT_CC: "通知电子邮件（抄送）",
    EMAIL_RECEIVE_BOOKING_ALERT_BCC: "通知电子邮件（密送）",
    DISPLAY_LANGUAGE_AND_WEEKEND: "显示语言和周末",
    DISPLAY_LANGUAGE: "语言",
    WEEKEND: "周末",
    CURRENCY_AND_TAXES_FEES: "货币和税费/附加费",
    CURRENCY_USED_IN_SYSTEM: "货币",
    VAT_RATE_IS_APPLIES: "增值税百分比",
    SERVICE_TAX_RATE_APPLIES: "服务费率",
    PRICES_INCLUDE_TAXES_FEES: "价格已包含税费/附加费",
    REGULATIONS_ON_CHILD_AGE_AND_ACCOMPANING_FEE: "儿童年龄和陪伴费用规定",
    YOUTH_IS_FREE_OF_CHARGE: "婴儿最大年龄",
    AGE_CHILD_EXTRA_CHARGE: "儿童最大年龄",
    OTHER_INFOMATION: "其他信息",
    CHECKIN_TIME: "入住时间",
    CHECKOUT_TIME: "退房时间",
    YEAR_BUILT: "建造年份",
    TOTAL_NUMBER_OF_FLOORS: "楼层总数",
    DISTANCE_TO_AIRPORT: "距离机场的距离",
    DISTANCE_TO_CITY_CENTER: "距离市中心的距离",
    TIME_TO_AIRPORT: "到机场时间（分钟）",
    VOLTAGE_USED: "使用电压",
    ROOM_SERVICE: "客房服务",
    HOTEL_RULES: "酒店政策",
    //#endregion

    //#region payment policy
    EFFECTIVE_DATE: "生效日期",
    DEPOSIT_BEFORE_CHECKIN: "入住前支付押金",
    PERCENT: "百分比",
    AMOUNT_OF_MONEY: "金额",
    PREPAYMENT_BEFORE_CHECKIN_DATE: "入住前支付款项",
    PAYMENT_BEFORE_CHECKOUT_DATE: "退房前支付款项",
    PAYMENT_BEFORE_DAY_CHECKIN_DATE: "入住当天支付款项",
    ADD_NEW_PAYMENT_POLICY: "添加新支付政策",
    DEPOSIT_LEVEL_APPLIES: "适用押金等级",
    TIME_APPLICATION: "入住日期",
    // #endregion

    // #region cancellation policy
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE_CHECKIN: "在入住前x天内取消预订",
    FIXED_MONEY: "固定金额",
    ADD_NEW_CANCELLATION_POLICY: "添加新取消政策",
    FINES_APPLY: "罚款适用",
    // #endregion

    // #region Header
    PERSONAL_ACCOUNT_SETTING: "个人账户设置",
    LOG_OUT: "退出",
    FEEDBACK_SUCCESS: "反馈成功",
    // #endregion

    _LOGIN: {
        LOGIN: "登录",
        USERNAME: "用户名",
        PASSWORD: "密码",
        FORGOT_PASSWORD: "忘记密码",
        REGISTER_NOW: "立即注册",
        LOOKING_AGENT: "寻找代理商？",
        LOGIN_HERE: "点击这里登录",
        INVALID_ACCOUNT_INFO_MESSAGE: "用户名或密码错误！",
        SESSION_EXPIRED: "您的会话已过期！",
        HAS_NO_ACCESS: "登录账号无效！",
        SESSION_EXPIRED_MESSAGE: "出于安全原因，本次会话在一段时间无操作后会过期。继续操作，请输入您的用户名和密码重新登录。",
        ARE_YOU_FORGOT_PASSWORD: "您忘记密码了吗？",
        ENTER_EMAIL_USERNAME: "请输入您的电子邮件或用户名，收到重置密码的邮件！",
        EMAIL_USERNAME: "电子邮件或用户名",
        EMAILADDRESS_ERROR_REQUIRED: "请再次检查您的电子邮件！",
        EMAIL_NOT_EXIST: "您的电子邮件或用户名不存在，请重试！",
        REQUEST_RESET_PASS_NOTICE: "您的密码重置请求已成功",
        SEND_NEW_PASS: "新密码已发送，请检查您的电子邮件！",
        CANCEL: "取消",
        RESET: "确认",
        HOTELID: "酒店ID",
        EZID_LOGIN: "使用ezID登录"
    },
    _RESET: {
        NOT_VALID_REQUEST: "您的重置请求已失效"
    },
    _REGISTER: {
        OTA_GROUP: "销售渠道组",
        OTA: "销售渠道",
        WELCOME: "欢迎来到ezCrs - 专为我们的酒店设计",
        SOLOGAN: "今天就注册，我们将全程为您提供帮助。从开始到结束，您可以与我们一起预订各种产品并销售给您的客户。立即加入我们！！！",
        PERSONAL_DETAIL: "个人信息",
        HOTEL_DETAIL: "酒店信息",
        CREATE_ACCOUNT: "创建账户",
        ENTER: "进入",
        HOTEL_EMAIL: "酒店电子邮件",
        ENTER_EMAIL: "输入电子邮件",
        ENTER_TAX_CODE: "输入税号",
        ENTER_ROOM_QUANTITY: "输入房间数量",
        YOUR_COMPANY_NAME: "您的公司/品牌名称",
        YOUR_WEBSITE_LINK: "您的酒店网站链接",
        SELECT: "选择",
        REQUIRED: "必填",
        FULLNAME: "全名",
        YOUR_FULLNAME: "您的全名",
        PERSONAL_PHONE: "个人电话号码",
        MALE: "男性",
        FEMALE: "女性",
        EMAIL: "电子邮件",
        YOUR_EMAIL: "您的电子邮件",
        POSITION: "职位/头衔",
        YOUR_POSITION: "您的职位/头衔",
        HOTEL_NAME: "酒店名称",
        HOTEL_TYPE: "酒店类型",
        TAX_CODE: "税号",
        COUNTRY: "国家",
        WARD: "街道",
        WEBSITE: "网站",
        STAR: "星级",
        CITY: "城市/省",
        ADDRESS: "地址",
        HOTEL_PHONE: "酒店电话号码",
        NUMBER_OF_ROOMS: "房间数量",
        DISTRICT: "区/公社/特区",
        USERNAME: "用户名",
        CREATE_NEW_ACCOUNT_NAME: "创建新账户名称",
        PASSWORD: "密码",
        CREATE_PASSWORD: "创建密码",
        RETYPE_PASSWORD: "重新输入密码",
        PASSWORD_NOT_MATCH: "密码不匹配",
        PHONE_NUMBER_NOT_LESS_THAN: "电话号码不能少于8个字符",
        PASSWORD_NOT_LESS_THAN: "密码不能少于8个字符",
        VALID_USERNAME_MESSAGE: "选择一个只包含字母和数字的用户名",
        BY_CLICKING_REGISTER: "点击注册即表示您同意我们的",
        TERM_AND_CONDITIONS: "条款和条件",
        PRIVACY_POLICY: "隐私政策",
        AGREE_POLICY_MESSAGE: "点击注册即表示您同意我们的条款和条件及隐私政策",
        THANKS_FOR_REGISTER: "感谢您的注册！",
        WAIT_APPROVE: "您的账户已创建，正在等待审核。",
        UPLOAD_CERTIFICATE_MESSAGE: "请上传营业执照以帮助我们验证并发放账户。我们将在48小时内确认您的账户。",
        REQUIRED_FIELD: "必填字段",
        ACCOUNT_ALREADY_EXISTS: "账户已存在",
        REGISTER: "注册",
        NEXT: "下一步",
        BACK: "返回",
        UPLOAD_FILE: "上传文件",
        COMPLETE_AND_LOGIN: "完成并返回主页"
    },
    // support
    _SUPPORT: {
        TITLE: "网站集成预订引擎的说明"
    },
    // Dashboard
    _DASHBOARD: {
        TITLE: "仪表盘",
        IN_MONTH_REVENUE: "本月收入（越南盾）",
        SEVEN_DAY_REVENUE: "过去7天的收入（越南盾）",
        COLLECTION: "应收账款（越南盾）",
        ROOM_FILLING_RATE: "本月房间入住率",
        BOOKING_EMPTY: "新的预订将在这里显示",
        BOOKING_TIME: "预订时间",
        BOOKING_CODE: "预订代码",
        AGENCY: "代理商",
        TIME_STAY: "住宿日期",
        PACKAGE: "订阅套餐",
        TOTAL: "总计（越南盾）",
        PAYMENT_STATUS: "支付状态",
        BOOKING_NOT_PAYMENT: "未付款预订",
        BOOKING_PART_PAYMENT: "部分付款预订",
        BOOKING_CANCELED: "预订已被客户取消",
        GO_TO_BOOKING_LIST: "查看完整预订列表",
        STATUS: "状态",
        HOTEL_STATUS: "酒店信息",
        CONTRACT: "合同",
        DEBT: "负债",
        SYNC_PMS: "同步PMS",
        MISSING_INFO: {
            SYNC_OTA: "渠道同步",
            SYNC_OTA_SUB_TITLE: "至少同步一个渠道",
            LIMITATIONS: "声明限制",
            RESTRICTION_SUB_TITLE: "至少声明一个限制",
            RATE_PLAN: "声明价格、房间库存",
            RATE_PLAN_SUB_TITLE: "为一个渠道和房间库存声明最小值",
            TITLE: "填写必要信息",
            HOTEL_INFO: "酒店信息",
            HOTEL_INFO_SUB_TITLE: "填写必填字段",
            ROOM_TYPE: "房间类型信息",
            ROOM_TYPE_SUB_TITLE: "声明至少一个房间类型",
            HOTEL_IMAGE: "酒店照片",
            HOTEL_IMAGE_SUB_TITLE: "上传至少一张图片",
            ROOM_PRICE: "价格计划",
            ROOM_PRICE_SUB_TITLE: "声明至少一个价格计划",
            HOTEL_SETTING: "酒店设置",
            HOTEL_SETTING_SUB_TITLE: "填写必填字段",
            BOOKING_CANCEL_POLICY: "取消政策",
            BOOKING_CANCEL_POLICY_SUB_TITLE: "声明至少一个政策",
            PAYMENT_GATE: "支付网关",
            PAYMENT_GATE_SUB_TITLE: "至少选择一个支付方式",
            CONTRACT: "合同",
            CONTRACT_SUB_TITLE: "填写必要字段",
            PAYMENT_POLICY: "支付政策",
            PAYMENT_POLICY_SUB_TITLE: "声明至少一个政策",
            CLOSE: "关闭",
            ROOM_PLAN: "房间计划",
            ROOM_PLAN_SUB_TITLE: "声明至少一个房间销售套餐",
            HOTEL_CONFIG: "酒店配置",
            HOTEL_CONFIG_SUB_TITLE: "填写必填字段"
        },
        CONFIRM: "确认",
        CONFIRM_SELL_ROOM: "我同意所有输入的信息绝对准确，并同意在OneInventory上发布房间出售",
        CONFIRM_SELL_ROOM_BUTTON: "确认出售房间",
        _HOTEL_STATUS_INFO: {
            CREATE: "创建",
            WAIT_CONFIRM: "等待确认",
            WAIT_APPROVE: "等待批准",
            APPROVED: "已批准",
            SENT_BACK: "已退回",
            ONSITE: "在场",
            OFFSITE: "不在场"
        },
        _HOTEL_STATUS_CONTRACT: {
            NOT_CREATED: "未创建",
            CREATE: "创建",
            RELEASED: "已发布",
            WAIT_SIGN: "等待签署",
            COMPLETED: "已完成",
            SIGNED: "已签署",
            IN_DISPUTE: "争议中",
            LIQUIDATED: "已清算",
            CLOSED: "已关闭"
        },
        _HOTEL_STATUS_DEBT: {
            NOT_CONFIGURED: "未配置",
            CONFIGURED: "已配置"
        },
        _HOTEL_STATUS_SYNC_PMS: {
            SYNCHRONIZED: "已同步",
            UNSYNCHRONIZED: "未同步",
            RECEIVED: "已接收",
            NOT_RECEIVED: "尚未接收"
        }
    },
    // END
    // Batch Update
    _BATCH_UPDATE: {
        TITLE: "批量更新",
        ADD: "添加",
        SELECT_ROOM_TYPE: "选择房间类型",
        SELECT_UPDATE_TYPE: "选择更新",
        ALL_ROOM: "所有房间",
        AVAILABLE_ROOM: "库存",
        PRICE: "价格",
        STOP_SELL: "停止销售",
        CTA: "关闭到达",
        CTD: "关闭离开",
        MIN_NIGHT_STAY: "最少入住夜数",
        MAX_NIGHT_STAY: "最多入住夜数",
        ROOM_TYPE_AND_SALE_PACKAGE: "房间类型 / 价格计划",
        FROM: "从",
        TO: "到",
        MESSAGE: {
            OVERLAP_TIME: "更新时间间隔不能重叠"
        },
        APPLY: "应用",
        DELETE_STOP_SELL: "删除停止销售",
        DELETE_CTA: "删除关闭到达",
        DELETE_CTD: "删除关闭离开"
    },
    // Booking
    _BOOKING: {
        TITLE: "预订列表",
        BOOKING: "0个预订 | 1个预订 | {count}个预订",
        BOOKING_DATE: "预订日期",
        BOOKING_CODE: "预订代码",
        REQUEST_CODE: "请求代码",
        REQUEST_DATE: "请求日期",
        REQUEST_STATUS: "请求状态",
        AGENT_NAME: "代理商",
        TIME_STAY: "入住日期",
        COMBO: "订阅套餐",
        COMBO_REQUEST: "请求套餐",
        AMOUNT: "总金额",
        BOOKING_STATUS: "预订状态",
        EXPORT: "导出到Excel",
        SEARCH: "搜索",
        RESET: "重置",
        ENTER_BOOKING_CODE: "输入预订代码",
        ENTER_BOOKING_CODE_OTA: "输入OTA预订代码",
        ENTER_BOOKING_GROUP_CODE: "输入团体预订代码",
        SEARCH_CONDITION: "按以下条件搜索",
        SEARCH_BOOKING_CODE: "预订代码",
        SEARCH_DATE: "选择日期范围",
        EDIT: "编辑",
        CONFIRM_FEEDBACK: "确认已发送请求给代理商",
        CONFIRM_FEEDBACK_REASON: "反馈内容",
        SEARCH_BY: {
            BOOKING_CODE: "预订代码",
            REQUEST_DATE: "请求日期",
            BOOKING_DATE: "预订日期",
            CHECKIN_DATE: "入住日期",
            CHECKOUT_DATE: "退房日期",
            STAYING_DATE: "入住日期"
        },
        STATUS: {
            ALL: "所有",
            CANCEL: "已取消（客户）",
            AWAIT_PAYMENT: "等待付款",
            CLOSE: "已关闭",
            IN_SERVICE: "服务中",
            PAYMENT_FAILED: "支付失败",
            CONFIRM: "已确认",
            AWAIT_FULLY_PAYMENT: "部分付款",
            VOID: "已取消（酒店）",
            STATUS_WAIT_FEEDBACK: "等待反馈",
            STATUS_FEEDBACK: "已反馈",
            STATUS_COMPLETE: "已完成",
            STATUS_CANCEL: "已取消"
        },
        SEARCH_PMS_STATUS: "同步状态",
        SEARCH_PMS_CODE: "PMS类型",
        CHECKIN_STATUS: "入住状态",
        AGENT: "旅行社",
        MARKET: "市场细分",
        PDF: "导出PDF",
        UNMAP_BOOKING: {
            UNMAP_BOOKING_TITLE: "Mapping status",
            ALL: "All",
            MAPPED: "Mapped",
            UNMAP_ROOM_TYPE: "Unmapped room",
            UNMAP_RATE_PLAN: "Unmapped rate",
            UNMAP_ROOMRATE: "Unmapped room_rate",
        }
    },
    _BOOKING_DETAIL: {
        TITLE: "预订详情",
        CONTACT: {
            TITLE: "联系方式",
            NAME: "客人姓名",
            PHONE: "电话号码",
            EMAIL: "电子邮件",
            GROUP_NAME_TOUR: "团体名称",
            AGENT_NAME: "代理商"
        },
        BOOKING_DETAIL: {
            TITLE: "预订信息",
            CODE: "预订代码",
            OTACODE: "OTA预订代码",
            STATUS: "预订状态",
            CREATED: "预订日期",
            CHECK_IN: "入住日期",
            CHECK_OUT: "退房日期",
            UPDATED: "更新日期",
            NOTE: "备注"
        },
        ROOM: {
            TITLE: "房间详情 -",
            APPLY_DATE: "日期",
            NAME: "价格计划",
            UNIT_PRICE: "价格/晚（越南盾）",
            QUANTITY: "房间数量",
            ADULTS: "成人",
            CHILDREN: "儿童",
            BABY: "婴儿",
            TOTAL: "金额（越南盾）"
        },
        PROMOTION_ONEI: {
            TITLE: "促销 One Inventory",
            NAME: "促销名称",
            COST_TYPE: "费用类型",
            TOTAL: "金额（越南盾）"
        },
        PROMOTION: {
            TITLE: "促销",
            NAME: "促销名称",
            ROOM_PLAN_NAME: "价格计划",
            ROOM_NAME: "房间类型",
            TOTAL: "金额（越南盾）"
        },
        SERVICE: {
            TITLE: "服务",
            NAME: "服务名称",
            DATE: "使用日期",
            COST: "价格",
            COUNT: "数量",
            TOTAL: "金额（越南盾）"
        },
        PAYMENT_LOG: {
            TITLE: "支付历史",
            METHOD: "支付方式",
            AMOUNT: "金额",
            TRANS_NO: "交易代码",
            TRANS_DATE: "交易日期",
            RES_CODE: "结果",
            RES_MSG: "备注"
        },
        METHOD_NAME: {
            ONEPAY_DOM: "国内Onepay支付",
            ONEPAY_INTER: "国际Onepay支付",
            VNPAY: "Vnpay支付",
            TRANSFER: "转账支付",
            CASH: "现金支付",
            VNPAY_QR: "Vnpay二维码支付",
            VIETTELPAY_QR: "Viettelpay二维码支付",
            VIETTELPAY: "Viettelpay支付"
        },
        PAYMENT_CARD_DETAIL: "支付卡详情",
        SUB_TOTAL: "小计",
        TOTAL: "总金额",
        PAID: "已付款金额：",
        UNPAID: "未付款金额：",
        EXPORT: "打印预订",
        CANCEL: "取消预订",
        NOTE: "备注",
        CONFIRM_CANCEL: "确认取消预订？",
        CONFIRM_REASON: "理由（必填）",
        CONFIRM: "确认",
        COMMISSION: "佣金",
        BEFORE_COMMISSION: "收到的净金额",
        AFTER_COMMISSION: "包含佣金的价格",
        PAYMENT_COLLECT: "支付收集",
        PROPERTY_COLLECT: "资产收集",
        OTA_CONTACT: "OTA 联系方式",
        CHANNEL_COLLECT: "渠道收集"
    },
    _REQUEST_DETAIL: {
        TITLE: "请求详情",
        BUGET: "已支付预算",
        CONTACT: {
            TITLE: "预订联系人详情",
            NAME: "客人姓名",
            PHONE: "电话号码",
            EMAIL: "电子邮件",
            AGENT_NAME: "代理商",
            REQUESTER_NAME: "请求者姓名"
        },
        BOOKING_DETAIL: {
            TITLE: "请求详情",
            CODE: "请求代码",
            STATUS: "请求状态",
            CREATED: "请求日期",
            CHECK_IN: "入住日期",
            CHECK_OUT: "退房日期",
            UPDATED: "更新日期"
        },
        ROOM: {
            TITLE: "房间详情",
            APPLY_DATE: "日期",
            NAME: "价格计划",
            UNIT_PRICE: "价格/晚（越南盾）",
            QUANTITY: "房间数量",
            ADULTS: "成人",
            CHILDREN: "儿童",
            TOTAL: "金额（越南盾）"
        },
        NOTE: "备注",
        SEND_REQUEST: "反馈"
    },
    _BOOKING_TRANSACTION: {
        TITLE: "收支交易",
        ALL: "所有",
        BOOKING: "预订房间",
        BOOKING_DATE: "预订日期",
        BOOKING_CODE: "预订代码",
        AGENT_NAME: "代理商",
        TIME_STAY: "入住日期",
        AMOUNT: "总金额",
        PAYMENT_DATE: "支付日期",
        BOOKING_STATUS: "预订状态",
        ACTION: "操作",
        EXPORT: "导出到Excel",
        SEARCH: "搜索",
        CONFIRM: "确认",
        TIME_STAY_TEXT: "{day} 天 {night} 晚",
        SEARCH_CONDITION: "按以下条件搜索",
        SEARCH_BOOKING_CODE: "输入代码",
        SEARCH_DATE: "日期范围",
        SEARCH_BY: {
            BOOKING_CODE: "预订代码",
            BOOKING_DATE: "预订日期",
            CHECKIN_DATE: "入住日期",
            CHECKOUT_DATE: "退房日期"
        },
        STATUS: {
            CANCEL: "已取消（客户）",
            AWAIT_PAYMENT: "等待付款",
            CLOSE: "已关闭",
            IN_SERVICE: "服务中",
            PAYMENT_FAILED: "支付失败",
            CONFIRM: "已确认",
            AWAIT_FULLY_PAYMENT: "部分付款",
            VOID: "已取消（酒店）"
        }
    },
    _BOOKING_TRANSACTION_DETAIL: {
        TITLE: "交易详情",
        DETAIL: "交易详情",
        BOOKING_CODE: "预订代码：",
        PAYMENT_METHOD: "支付方式",
        TRANSACTION_CODE: "交易代码",
        TRANSACTION_DATE: "交易日期",
        AMOUNT: "金额",
        NOTE: "备注",
        BANK_TRANSFER: "转账",
        CASH: "现金",
        DEBT: "债务"
    },
    // END

    // Sale room plan
    _ROOM_PLAN: {
        TITLE: "房间和价格计划",
        BATCH_UPDATE: "批量更新",
        ALL_ROOM: "所有房间",
        STOP_SELL: "停止销售",
        MIN_STAY: "最短入住天数",
        MAX_STAY: "最长入住天数",
        CTA: "入住前关闭",
        CTD: "退房前关闭",
        CURRENT_MONTH: "{month}/{year}",
        CONFIRM_CHANGE_PAGE: "未保存的数据将会丢失\n你确定要继续吗？",
        MIN_SMALLER_THAN_ONE: "最短入住天数不能小于1",
        MAX_SMALLER_THAN_ONE: "最长入住天数不能小于1",
        MIN_BIGGER_THAN_MAX: "最短入住天数不能大于最长入住天数",
        MIN_SMALLER_THAN_CONFIG: "最短入住天数不能小于配置的最短入住天数",
        MAX_BIGGER_THAN_CONFIG: "最长入住天数不能大于配置的最长入住天数"
    },
    // END

    SALE_PACKAGE: "价格计划",
    // Hotel chain
    _HOTEL_CHAIN: {
        CHAIN_LIST_HOTEL: "酒店",
        TITLE: "酒店链",
        CHAIN_NAME: "链名",
        CHAIN_LIST: "酒店列表（{total}）",
        HOTEL_ID: "酒店ID: ",
        ADD_HOTEL: "添加酒店",
        LOGIN_TEXT: "更改酒店信息，请使用酒店所有者账户登录",
        LOGIN_EXISTED_TEXT: "账号登录 {hotelName}:",
        USERNAME: "用户名",
        PASSWORD: "密码",
        CONFIRM: "确认",
        REMOVE_HOTEL: "您确定要从链中移除选定的酒店吗？",
        LOGIN: "登录",
        DELETE_HOTEL: "从链中移除",
        LABEL_SEARCH_CODE_NAME: "酒店代码/名称",
        ENTER_HOTEL_NAME_OR_CODE: "输入酒店名称或酒店代码",
        CHAIN_LIST_BOOKING: "预订",
        STATUS: "状态",
        SEARCH: "搜索"
    },

    // END

    // Tài khoản cá nhân
    _ACCOUNT_SETTING: {
        TITLE: "个人账户设置",
        AVATAR: "头像",
        USER_INFO: "个人信息",
        CHANGE_PASSWORD: "更改密码",
        USERNAME: "用户名",
        FULLNAME: "全名",
        PASSWORD: "密码",
        PASSWORD_REPEAT: "确认密码",
        GENDER: "性别",
        GENDER_MALE: "男性",
        GENDER_FEMALE: "女性",
        EMAIL: "电子邮件",
        PHONE_NUMBER: "电话号码",
        ADDRESS: "地址",
        POSITION: "职位",
        GROUP: "用户组",
        CURRENT_PASS: "当前密码",
        NEW_PASS: "新密码",
        NEW_PASS_REPEAT: "重复新密码",

        ERROR_PHONE_NUMBER_MIN: "电话号码至少需要8个字符",
        ERROR_PASSWORD_MIN: "密码至少需要8个字符",
        ERROR_RETYPE_PASSWORD_MIN: "确认密码至少需要8个字符",
        ERROR_PASSWORD_INVALID: "当前密码不正确",
        ERROR_PASSWORD_NOT_MATCH: "密码不匹配",
        MESSAGE_PASSWORD_MATCHED: "密码匹配",
        MESSAGE_PASSWORD_NOT_MATCHED: "密码不匹配"
    },
    // END
    _LIST_USER: {
        TITLE: "用户管理",
        LIST_USER: "用户",
        USER: "用户",
        SEARCH_PLACEHOLDER: "通过用户名、全名或电子邮件搜索",
        GROUP_NAME: "组名",
        USERNAME: "用户名",
        NAME: "全名",
        EMAIL: "电子邮件",
        CREATE_USER: "创建者",
        CREATE_DATE: "创建日期",
        STATUS: "状态",
        ACTION: "操作",
        STATUS_ACTIVATE: "激活",
        STATUS_DEACTIVATE: "非激活",
        REMOVE: "确认删除此用户？",
        CANNOT_DELETE_CURRENT_USER: "无法删除当前用户"
    },
    // Quản lý nhóm người dùng - danh sách
    _LIST_GROUP: {
        TITLE: "用户组管理",
        LIST_GROUP: "用户组",
        GROUP: "用户组",
        SEARCH_PLACEHOLDER: "通过用户组名搜索",
        GROUP_NAME: "组名",
        CREATE_USER: "创建者",
        CREATE_DATE: "创建日期",
        STATUS: "状态",
        ACTION: "操作",
        STATUS_ACTIVATE: "激活",
        STATUS_DEACTIVATE: "非激活",
        DESCRIPTION: "描述信息",
        REMOVE: "确认删除此组？"
    },
    // END
    // Quản lý người dùng - Thêm/sửa
    _EDIT_USER: {
        TITLE: "用户信息",
        INFO: "用户信息",
        USER: "用户",
        ROLE: "访问权限",
        USERNAME: "用户名",
        FULLNAME: "全名",
        PASSWORD: "密码",
        PASSWORD_REPEAT: "确认密码",
        GENDER: "性别",
        GENDER_MALE: "男",
        GENDER_FEMALE: "女",
        EMAIL: "电子邮件",
        PHONE_NUMBER: "电话号码",
        ADDRESS: "地址",
        POSITION: "职位",
        GROUP: "用户组",
        GROUP_PLACEHOLDER: "搜索",
        HOTEL_OWNER: "酒店业主",
        STATUS: "状态（激活/非激活）",
        N_O: "序号",
        FUNCTION_CODE: "功能代码",
        FUNCTION_NAME: "功能名称",
        ACTION: "操作",
        ERROR_PHONE_NUMBER_MIN: "电话号码必须至少8个字符",
        ERROR_PASSWORD_MIN: "密码至少输入8个字符",
        ERROR_RETYPE_PASSWORD_MIN: "确认密码至少输入8个字符",
        ERROR_PASSWORD_NOT_MATCH: "密码不匹配",
        CHAIN: "连锁酒店",
        HOTEL: "酒店"
    },
    // END

    // Quản lý nhóm người dùng - Thêm/sửa
    _EDIT_GROUP: {
        TITLE: "用户组信息",
        INFO: "用户组信息",
        GROUP: "用户组",
        ROLE: "访问权限",
        GROUP_NAME: "组名",
        GROUP_CODE: "组代码",
        GROUP_ROLE: "组角色",
        PARENT_GROUP: "父级组",
        TYPE: "组类型",
        DESCRIPTION: "描述信息",
        STATUS: "状态（激活/非激活）",
        NO: "序号",
        FUNCTION_CODE: "功能代码",
        FUNCTION_NAME: "功能名称",
        ACTION: "操作",
        ERROR_MIN_ROLE_SELECTED: "请至少选择1个功能屏幕"
    },
    // END

    // Hợp đồng điện tử
    _CONTRACT: {
        TITLE: "电子合同",
        CONTRACT_INFO: "法律信息",
        BUSINESS_NAME: "公司名称",
        BUSINESS_NAME_NOTE: "（正确填写营业执照，公司名称大写）",
        TAX_CODE: "税号",
        TAX_CODE_NOTE: "（填写正确的税号，包含所有零）",
        ADDRESS: "注册地址",
        ADDRESS_NOTE: "（根据营业执照填写）",
        BANK_ACCOUNT: "银行账户号码",
        BANK_ACCOUNT_OWNER: "银行账户持有人姓名",
        BANK: "银行名称",
        BANK_BRANCH: "银行分行",
        LEGAL_REPRESENTATIVE: "法定代表人",
        LEGAL_REPRESENTATIVE_NOTE: "（根据营业执照填写）",
        PIC: "合同签署人",
        PIC_POSITION: "签署职位",
        COMMISSION: "佣金（%）",
        STATUS: "合同状态",
        VIEW: "查看",
        _STATUS: {
            CREATE: "创建",
            AM_SENT: "AM已发送",
            SM_ACCEPT: "SM已接受",
            SM_REJECT: "SM已拒绝",
            CM_ACCEPT: "CM已接受",
            CM_REJECT: "CM已拒绝",
            PUBLISH: "发布",
            WAIT_SIGN: "等待签署",
            COMPLETE: "完成",
            SIGNED: "已签署",
            DISPUTED: "有争议",
            LIQUIDFY: "清算",
            CLOSE: "关闭",
            EXTEND: "延长"
        }
    },
    // END

    // Danh sách đại lý hợp tác
    _TRAVEL_AGENT: {
        TITLE: "代理商列表",
        TITLE_DEACTIVE: "停止合作的代理商列表",
        AGENT: "代理商",
        SEARCH_PLACEHOLDER: "按代理商名称搜索",
        NAME: "代理商名称",
        BUSINESS_TYPE: "商业类型",
        TAX_CODE: "税号",
        LEVEL: "代理商级别",
        STATUS: "状态",
        DEACTIVE: "解除绑定",
        ACTIVE: "恢复绑定",
        LEVEL_1: "级别 1",
        LEVEL_2: "级别 2",
        LEVEL_3: "级别 3",
        LEVEL_4: "级别 4",
        LEVEL_5: "级别 5",
        CONFIRM_CHANGE_LEVEL: "确认更改级别？",
        CONFIRM_ACTIVE: "确认与代理商的关联？",
        CONFIRM_DEACTIVE: "确认解除代理商的绑定？",
        CONFIRM_REASON: "原因（必填）",
        CONFIRM: "确认"
    },
    // END
    _VALIDATE: {
        REQUIRED: "请输入所有必要的信息",
        EMAIL_FORMAT: "请检查您的电子邮件格式",
        MIN_LENGTH: "输入的值必须超过 {minLength} 个字符",
        MAX_LENGTH: "输入的值必须少于 {maxLength} 个字符",
        REQUIRED_AT_LEAST_ONE_HOTEL_OR_CHAIN: "至少选择一个酒店或连锁酒店给用户"
    },

    /* beautify preserve:start */
    _ROLES: {
        CHAIN: "链条菜单",
        BOOKING_CHAIN: "链条和酒店预订",
        CHAIN_LIST: "链条列表",
        USER_MANAGEMENT: "用户管理",
        // USER_GROUP: "用户组",
        DASHBOARD: "仪表盘",
        MANAGE: "管理",
        BOOKING_HOTEL: "单一酒店预订",
        ROOM_SALE: "房间销售",
        ROOM_SALE_MANAGEMENT: "房间销售管理",
        SALE_PACKAGE_MANAGEMENT: "房价计划管理",
        OTA_MANAGEMENT: "ezCms Vela",
        SETTING: "设置",
        ACCOUNT_INFOMATION: "账户配置",
        PERSONAL_ACCOUNT: "个人账户信息",
        GENERAL_INFORMATION: "一般信息",
        HOTEL_AMENITY: "酒店设施",
        HOTEL_IMAGE: "酒店图片",
        NEARBY_PLACE: "附近的地方",
        ROOM_TYPE: "房型",
        ROOM_INFORMATION: "房间信息",
        ROOM_AMENITY: "房间设施",
        ROOM_IMAGE: "房间图片",
        HOTEL_CONFIGURATION: "酒店配置",
        GENERAL_CONFIGURATION: "一般配置",
        PAYMENT_POLICY: "支付政策",
        CANCELLATION_POLICY: "取消政策",
        IMAGE_LIBRARY: "图片库",
        HISTORY_LOG: "历史日志",
        PAYMENT_METHOD: "支付方式",
        BOOKING_ENGINE: "预订引擎",
        BOOKING_ENGINE_CONFIG: "配置",
        HOTEL_EMAIL: "电子邮件",
        HOTEL_BOOKING_CONFIRM: "确认预订",
        HOTEL_SERVICE: "服务",
        HOTEL_PROMOTION: "促销",
        HOTEL_INFORMATION: "酒店信息",
        BOOKING_MANAGEMENT: "预订",
        SYNC_MANAGEMENT: "频道同步",
        HEADER_FOOTER: "模板",
        SU_MANAGEMENT: "ezCms Leo",
        SU_CONNECTION: "销售渠道",
        SU_MAPPING: "映射",
        HOTEL_BOOKING_REPOST: "重新发布预订",
        CHAIN_SERVICE: "服务",
        CHAIN_ROOM_TYPE: "房型信息",
        CHAIN_RATE_PLAN: "房间销售套餐",
        CHAIN_TRAVEL_AGENT: "公司和代理商信息",
        HOTEL_TRAVEL_AGENT: "公司和代理商信息",
        SITEMINDER_MANAGEMENT: "ezCms SiteMinder",
        GDS_MANAGEMENT: "ezCms GDS",
        RMS_MANAGEMENT: "收益管理",
        DYNAMIC_PRICING: "动态定价",
        MASTER_RATE: "主价格",
        PACKAGE_MANAGEMENT: "套餐管理",
        PACKAGE_ITEM: "套餐项目",
        PACKAGE_DEAL: "套餐交易",
        BE_MANAGEMENT: "ezBe",
        HOTEL_BOOKING_GROUP: "预订组",
        BOOKING_UNMAP_HOTEL: "取消预订映射",
        HOTEL_DASHBOARD_IGNORE_TASK: "忽略",
        HOTEL_DASHBOARD_REUPDATE_TASK: "重新更新",
        HOTEL_BOOKING_UNMAP_REPOST: "重新发布预订",
        CHAIN_ROOM_UPDATE_QUANTITY: "更新房间数量",
        HOTEL_DASHBOARD: "仪表盘",
        ROOM_UPDATE_QUANTITY: "更新房间数量",
        DYNAMIC_RESTRICTION: "动态限制",
        DYNAMIC_ROOM_SALE: "动态房间销售",
        DYNAMIC_CONFIGURATION: "配置",
        CHAIN_BOOKING_REPOST: "重新发布预订",
        INVENTORY: "库存",
        RATE: "价格",
        RESTRICTION: "限制",
        STOP_SELL_LIMIT: "销售限制",
        CHANNEX_MANAGEMENT: "ezCms Vela+",
        CHANNEX_CONNECTION: "销售渠道",
        CHANNEX_MAPPING: "映射",
        WARNING_METHOD: "警告方式",
        STAAH_MANAGEMENT : "ezCms StaahMax",
        STAAH_MAPPING: "映射",
        STAAH_CONNECTION: "销售渠道",
    },

    /* beautify preserve:stop */
    _LEFT_MENU: {
        COPY_RIGHT: "版权 © 2021 ezCloud 保留所有权利"
    },
    _ACTIVITY: {
        ACTION_DATE: "操作日期",
        ACTION_BY: "操作人",
        APPLY_DATE: "申请日期",
        CREATED_DATE: "创建日期",
        ROOM_NAME: "房间名称",
        RATE: "价格",
        CREATE_DATE: "创建日期",
        SEARCH_DATE: "申请日期",
        USER_NAME: "账户",
        ROOM: "房间",
        ROOM_PLAN: "房价计划",
        YES: "是",
        NO: "否",
        STOPSELL: "停止销售",
        MINSTAY: "最少入住",
        CLOSEDTOARRIVE: "即将到达",
        MAXSTAY: "最多入住",
        CLOSEDTODEPATURE: "即将离开",
        IPADDRESS: "IP 地址",
        CREATEDBY: "创建者",
        PAGING: "页码",
        DOCUMENT: "记录",
        ROOMAVAIL: "库存",
        ALLSELECT: "全选",
        HOTELID: "酒店ID",
        HOTELNAME: "酒店名称",
        DATABEFORE: "数据前",
        DATAAFTER: "数据后",
        ACTION: "操作",
        HOTEL_LOGIN: "登录",
        HOTEL_CANCEL_BOOKING: "取消预订",
        HOTEL_UPDATE_PAYMENT_BOOKING: "预订确认",
        HOTEL_REQUEST_BOOKING: "确认预订请求",
        HOTEL_ROOM_PLAN_CREATE: "创建新房价计划",
        HOTEL_ROOM_PLAN_UPDATE: "房价计划信息",
        HOTEL_ROOM_PLAN_COPY: "复制计划",
        HOTEL_ROOM_PLAN_DELETE: "删除计划",
        HOTEL_PROMOTION_CREATE: "创建新促销",
        HOTEL_PROMOTION_UPDATE: "促销信息",
        HOTEL_PROMOTION_COPY: "复制促销",
        HOTEL_PROMOTION_DELETE: "删除促销",
        HOTEL_PROFILE_UPDATE: "更新个人资料",
        HOTEL_AVATAR_ADD: "添加头像",
        HOTEL_AVATAR_REMOVE: "删除头像",
        HOTEL_CHANGE_PASSWORD_PROFILE: "更改密码",
        HOTEL_USER_CREATE: "创建用户",
        HOTEL_USER_UPDATE: "更新用户",
        HOTEL_USER_UPDATE_ROLE: "更新用户角色",
        HOTEL_USER_DELETE: "删除用户",
        HOTEL_GROUP_CREATE: "创建用户组",
        HOTEL_GROUP_UPDATE: "更新用户组",
        HOTEL_GROUP_UPDATE_ROLE: "更新用户组角色",
        HOTEL_GROUP_DELETE: "删除用户组",
        HOTEL_CONTRACT_UPDATE: "更新合同",
        HOTEL_INFO_UPDATE: "更新酒店信息",
        HOTEL_UPDATE_AMENITIES: "更新酒店设施",
        HOTEL_UPDATE_IMAGES: "添加新图片",
        HOTEL_DELETE_IMAGES: "删除图片",
        HOTEL_AREA_CREATED: "创建附近区域",
        HOTEL_AREA_UPDATED: "更新附近区域",
        HOTEL_AREA_DELETED: "删除附近区域",
        HOTEL_CHAIN_CREATED: "创建酒店链",
        HOTEL_CHAIN_UPDATED: "更新酒店链",
        HOTEL_ROOM_CREATED: "创建房间",
        HOTEL_ROOM_UPDATED: "更新房间",
        HOTEL_ROOM_COPY: "复制房间",
        HOTEL_ROOM_DELETED: "删除房间",
        HOTEL_ROOM_AMENITY: "更新房间设施",
        HOTEL_ROOM_ADD_IMAGES: "添加房间图片",
        HOTEL_ROOM_DELETE_IMAGES: "删除房间图片",
        HOTEL_UPDATE_HOTEL_SETTING_INFO: "更新酒店设置",
        HOTEL_PAYMENT_POLICY_CREATED: "创建支付政策",
        HOTEL_PAYMENT_POLICY_UPDATED: "更新支付政策",
        HOTEL_PAYMENT_POLICY_DELETED: "删除支付政策",
        HOTEL_CANCEL_POLICY_CREATED: "创建取消政策",
        HOTEL_CANCEL_POLICY_UPDATED: "更新取消政策",
        HOTEL_CANCEL_POLICY_DELETED: "删除取消政策",
        HOTEL_SETTING_PAYMENT_GATE: "设置支付网关",
        HOTEL_ADD_IMAGES_SLIDE: "添加幻灯片图片",
        HOTEL_DELETE_IMAGES_SLIDE: "删除幻灯片图片",
        HOTEL_REMOVE_CONNECT_AGENT: "取消代理连接",
        HOTEL_UPDATE_LEVEL_AGENT: "更新代理连接等级",
        HOTEL_RETURN_CONNECT_AGENT: "恢复代理连接",
        PMS_CONFIRM: "PMS确认",
        RATE_CATEGORY_CREATE: "创建新价格类别",
        RATE_CATEGORY_UPDATE: "价格类别详情",
        ROOM_CATEGORY_CREATE: "创建新房间类别",
        ROOM_CATEGORY_UPDATE: "房间类别详情"
    },
    STATUS_CREATE_NEW: "创建新建",
    STATUS_DELIVERED: "已交付",
    STATUS_SALE_SEND_HOTEL: "已发送酒店",
    STATUS_SALE_ADMIN_SEND_BACK: "SM 已退回",
    STATUS_SALE_ADMIN_PASSED: "SM 已通过",
    STATUS_QC_SENT_BACK_HOTEL: "QC 已退回酒店",
    STATUS_QC_PASSED_HOTEL: "QC 已通过酒店",
    STATUS_SALE_ADDITIONAL: "已发送信息",
    STATUS_QC_SENT_BACK_INFOR: "已退回信息",
    STATUS_QC_PASSED_INFOR: "信息通过",
    STATUS_ONSITE: "现场",
    STATUS_OFFSITE: "非现场",

    STATUS_SIGNED: "已签署",
    STATUS_WAITING_SIGN: "等待签署",
    STATUS_CLOSED: "已关闭",
    STATUS_IN_DISPUTE: "争议中",
    STATUS_LIQUIDATED: "已清算",
    STATUS_COMPLETED: "已完成",
    STATUS_CM_PASSED: "CM 已通过",
    STATUS_CM_SEND_BACK: "CM 已退回",
    STATUS_RELEASED: "已发布",
    STATUS_RENEWAL: "续约",
    STATUS_CHANGED: "状态已更改为",
    STATUS_NEW_CREATE: "创建新建",

    STATUS_AWAIT_PAYMENT: "等待付款",
    STATUS_AWAIT_FULLY_PAYMENT: "等待全额付款",
    STATUS_PAYMENT_FAILED: "付款失败",
    STATUS_CONFIRM: "确认",

    ALL: "所有",
    CANCEL: "客户取消",
    AWAIT_PAYMENT: "等待付款",
    IN_SERVICE: "在服务中",
    PAYMENT_FAILED: "付款失败",
    CONFIRM: "已确认",
    AWAIT_FULLY_PAYMENT: "部分付款",
    VOID: "酒店取消",
    STATUS_WAIT_FEEDBACK: "等待反馈",
    STATUS_FEEDBACK: "反馈",
    STATUS_COMPLETE: "已完成",
    STATUS_CANCEL: "已取消",

    BOOKING: "预订",
    BOOKING_STATUS: "预订状态",
    BOOKING_REQUEST_STATUS: "请求状态",
    CONTRACT_STATUS: "合同状态",
    TA_STATUS: "旅行代理商状态",
    HOTEL_STATUS: "酒店状态",
    SHOW_MORE: "查看更多",
    NOTIFICATION: "通知",
    HAS_JUST_JOINED_ONEI: "已加入 One Inventory",
    HAS_JUST_CREATED_ONEI: "已创建于 OneInventory.com",
    ANNEX_OF_CONTRACT: "合同附录号",
    YOUR_AGENT: "您的代理",
    NOTIFICATIONS: "通知",
    MARK_AS_READ: "标记为已读",
    CONTACT_NUMBER: "合同编号",
    HOTELS_CONTRACT: "酒店合同",
    AGENTS_CONTRACT: "代理合同",
    ADDENDUM_OF_CONTRACT: "附加合同编号",
    EXTEND_CONTRACT: "延长合同",
    BELONG_HOTEL: "属于酒店",
    BELONG_AGENT: "属于代理",
    AGENT: "代理",
    NEW_TA: "新代理",
    RE_RELEASE: "重新发布",
    AGO: "之前",
    MONTHS: "个月",
    YEARS: "年",
    SECONDS: "秒",
    MINUTES: "分钟",
    HOURS: "小时",
    NOW: "现在",
    DAYS: "天",
    REQUEST_EMPTY: "请求为空",
    STATUS_INCORRECT: "状态不正确",
    STATUS_CONTRACT_INCORRECT: "合同状态不正确",
    NO_NOTIFICATION: "没有新通知",
    ADDENDUM_STATUS: "附加状态",
    OVER_CHARACTER: "您已超出字符限制",
    HOTEL_LOG_bookingCode: "预订编号",
    HOTEL_LOG_agentName: "代理商名称",
    HOTEL_LOG_customer: "客户姓名",
    HOTEL_LOG_createdDate: "创建日期",
    HOTEL_LOG_checkinDate: "入住日期",
    HOTEL_LOG_checkoutDate: "退房日期",
    HOTEL_LOG_totalCost: "总费用",
    HOTEL_LOG_payableAmount: "应付金额",
    HOTEL_LOG_bookingStatus: "预订状态",
    HOTEL_LOG_active: "激活",
    HOTEL_LOG_amount: "金额/百分比",
    HOTEL_LOG_cancellationDay: "取消日期",
    HOTEL_LOG_cancellationType: "取消类型",
    HOTEL_LOG_startDate: "开始日期",
    HOTEL_LOG_endDate: "结束日期",
    HOTEL_LOG_hotelId: "酒店编号",
    HOTEL_LOG_type: "申请时间",
    HOTEL_LOG_notifyToEmail: "通知邮箱",
    HOTEL_LOG_notifyCCEmail: "抄送邮箱",
    HOTEL_LOG_notifyBCCEmail: "密送邮箱",
    HOTEL_LOG_includeTaxesInPrice: "价格包含税费",
    HOTEL_LOG_language: "语言",
    HOTEL_LOG_weekend: "周末",
    HOTEL_LOG_email: "电子邮件",
    HOTEL_LOG_checkinAfterHour: "入住时间后",
    HOTEL_LOG_checkoutBeforeHour: "退房时间前",
    HOTEL_LOG_roomServices: "客房服务",
    HOTEL_LOG_hotelPolicyVi: "酒店政策 VI",
    HOTEL_LOG_hotelPolicyEn: "酒店政策 EN",
    HOTEL_LOG_yearOfBuild: "建成年份",
    HOTEL_LOG_numberOfFloors: "楼层数",
    HOTEL_LOG_numberOfRooms: "房间数",
    HOTEL_LOG_minutesToAirport: "到机场的分钟数",
    HOTEL_LOG_babyAgeDetermine: "婴儿年龄确认",
    HOTEL_LOG_childAgeDetermine: "儿童年龄确认",
    HOTEL_LOG_electronicVoltage: "电子电压",
    HOTEL_LOG_distanceToAirport: "到机场的距离",
    HOTEL_LOG_serviceTaxPercent: "服务税百分比",
    HOTEL_LOG_valueAddedTaxPercent: "增值税百分比",
    HOTEL_LOG_distanceToCenter: "到市中心的距离",
    HOTEL_LOG_lat: "纬度",
    HOTEL_LOG_lng: "经度",
    HOTEL_LOG_phoneNum: "电话号码",
    HOTEL_LOG_hotLine: "热线电话",
    HOTEL_LOG_starRanking: "星级排名",
    HOTEL_LOG_website: "网站",
    HOTEL_LOG_addressVi: "地址 VI",
    HOTEL_LOG_addressEn: "地址 EN",
    HOTEL_LOG_hotelNameVi: "酒店名称 VI",
    HOTEL_LOG_hotelNameEn: "酒店名称 EN",
    HOTEL_LOG_hotelTypeVi: "酒店类型 VI",
    HOTEL_LOG_hotelTypeEn: "酒店类型 EN",
    HOTEL_LOG_cityVi: "城市 VI",
    HOTEL_LOG_countryVi: "国家 VI",
    HOTEL_LOG_locationVi: "省份 VI",
    HOTEL_LOG_cityEn: "城市 EN",
    HOTEL_LOG_areaVi: "区域 VI",
    HOTEL_LOG_countryEn: "国家 EN",
    HOTEL_LOG_locationEn: "省份 EN",
    HOTEL_LOG_areaEn: "区域 EN",
    HOTEL_LOG_descriptionVi: "描述 VI",
    HOTEL_LOG_descriptionEn: "描述 EN",
    HOTEL_LOG_depositType: "押金类型",
    HOTEL_LOG_cutOfDate: "押金支付前的天数",
    HOTEL_LOG_paymentDay: "付款天数",
    HOTEL_LOG_proNameVi: "促销名称 VI",
    HOTEL_LOG_proNameEn: "促销名称 EN",
    HOTEL_LOG_promoType: "类型",
    HOTEL_LOG_sessionType: "类型",
    HOTEL_LOG_discountOrSurcharge: "折扣/附加费",
    HOTEL_LOG_coupon: "优惠券",
    HOTEL_LOG_orderType: "应用类型",
    HOTEL_LOG_notApplyDates: "不适用日期",
    HOTEL_LOG_applyPlans: "应用计划",
    HOTEL_LOG_applyAgents: "应用代理",
    HOTEL_LOG_applyLevels: "应用代理级别",
    HOTEL_LOG_applyDays: "应用日期",
    HOTEL_LOG_bookType: "预定类型",
    HOTEL_LOG_fromDays: "从",
    HOTEL_LOG_toDays: "到",
    HOTEL_LOG_minOrder: "最小订单",
    HOTEL_LOG_freeForMinOrder: "最小订单免费",
    HOTEL_LOG_percentOrFixed: "百分比或固定金额",
    HOTEL_LOG_startBook: "开始预订日期",
    HOTEL_LOG_endBook: "结束预订日期",
    HOTEL_LOG_objectType: "对象类型",
    HOTEL_LOG_delete: "删除",
    HOTEL_LOG_promotionNameVi: "促销名称 VI",
    HOTEL_LOG_promotionNameEn: "促销名称 EN",
    HOTEL_LOG_promotionDesVi: "描述 VI",
    HOTEL_LOG_promotionDesEn: "描述 EN",
    HOTEL_LOG_code: "请求编号",
    HOTEL_LOG_note: "备注",
    HOTEL_LOG_requestStatus: "请求状态",
    HOTEL_LOG_fullName: "全名",
    HOTEL_LOG_gender: "性别",
    HOTEL_LOG_phoneNumber: "电话号码",
    HOTEL_LOG_position: "职位",
    HOTEL_LOG_address: "地址",
    HOTEL_LOG_maxChildren: "最多儿童数",
    HOTEL_LOG_maxAdults: "最多成人数",
    HOTEL_LOG_totalRoom: "总房间数",
    HOTEL_LOG_defaultPrice: "默认价格",
    HOTEL_LOG_weekendPrice: "周末价格",
    HOTEL_LOG_roomSize: "房间大小",
    HOTEL_LOG_numberOfExtraBeds: "额外床位数",
    HOTEL_LOG_bedTypeTitleVi: "房间名称 VI",
    HOTEL_LOG_bedTypeTitleEn: "房间名称 EN",
    HOTEL_LOG_viewVi: "房间景观 VI",
    HOTEL_LOG_viewEn: "房间景观 EN",
    HOTEL_LOG_bedTypeVi: "床型 VI",
    HOTEL_LOG_bedTypeEn: "床型 EN",
    HOTEL_LOG_sellAllotment: "配额",
    HOTEL_LOG_roomName: "房型",
    HOTEL_LOG_amenityName: "房间设施",
    HOTEL_LOG_id: "代码",
    HOTEL_LOG_nameVi: "名称 VI",
    HOTEL_LOG_nameEn: "名称 EN",
    HOTEL_LOG_adultsIncluded: "包含成人",
    HOTEL_LOG_exAdult: "额外成人费用",
    HOTEL_LOG_aexType: "成人类型",
    HOTEL_LOG_childrenInclued: "包含儿童",
    HOTEL_LOG_exChild: "额外儿童费用",
    HOTEL_LOG_cexType: "儿童类型",
    HOTEL_LOG_start: "开始日期",
    HOTEL_LOG_end: "结束日期",
    HOTEL_LOG_sesType: "住宿时间",
    HOTEL_LOG_minStay: "最短入住天数",
    HOTEL_LOG_maxStay: "最长入住天数",
    HOTEL_LOG_extraBedPrice: "额外床位费用",
    HOTEL_LOG_rooms: "房型",
    HOTEL_LOG_meals: "包含餐食",
    HOTEL_LOG_plans: "计划名称",
    HOTEL_LOG_promotions: "促销名称",
    HOTEL_LOG_avatar: "头像",
    HOTEL_LOG_userName: "用户名",
    HOTEL_LOG_userGroup: "用户组",
    HOTEL_LOG_owner: "职位",
    HOTEL_LOG_name: "名称",
    HOTEL_LOG_functions: "功能代码",
    HOTEL_LOG_users: "账户",
    HOTEL_LOG_description: "描述",
    HOTEL_LOG_enterpriseName: "企业名称",
    HOTEL_LOG_registeredAddress: "企业地址",
    HOTEL_LOG_taxCode: "税号",
    HOTEL_LOG_bankAccountNumber: "银行账户号码",
    HOTEL_LOG_bankAccountName: "银行账户名称",
    HOTEL_LOG_bankName: "银行名称",
    HOTEL_LOG_bankBranch: "银行分支",
    HOTEL_LOG_representative: "代表人",
    HOTEL_LOG_signer: "签署人",
    HOTEL_LOG_area: "区域",
    HOTEL_LOG_location: "地点",
    HOTEL_LOG_city: "城市",
    HOTEL_LOG_country: "国家",
    HOTEL_LOG_hotline: "热线电话",
    HOTEL_LOG_images: "图片名称",
    HOTEL_LOG_amenities: "设施名称",
    HOTEL_LOG_landmark: "地标",
    HOTEL_LOG_distance: "距离",
    HOTEL_LOG_unit: "单位",
    HOTEL_LOG_hotelChains: "酒店集团",
    HOTEL_LOG_roomId: "房间编号",
    HOTEL_LOG_views: "景观",
    HOTEL_LOG_agentId: "代理编号",
    HOTEL_LOG_areas: "区域名称",
    HOTEL_LOG_level: "代理级别",
    HOTEL_LOG_userGroups: "用户组名称",
    HOTEL_LOG_hotelType: "酒店类型",
    HOTEL_LOG_logo: "酒店标志",
    HOTEL_LOG_currency: "货币",
    HOTEL_LOG_pmsConfirm: "PMS",
    HOTEL_LOG_restriction: "限制",
    //
    OTHER_POLICY: "其他政策",
    IF_CANCELED: "如果您在",
    DAYS_PRIOR_TO_ARRIVAL_DATE: "天之前取消预订",
    OF_THE_BOOKING_VALUE_WILL_CHARGED: "预订金额的",
    WILL_BE_CHARGED: "您将被收取",
    WILL_BE_CHARGED_POCUP: "您将被收取",
    RESERVATIONS: "预订",
    REQUIES_A_DEPOSIT: "需要定金",
    OF_THE_BOOKING_VALUE: "预订金额的",
    THE_REMAINING_AMOUNT: "剩余金额必须在",
    THE_REMAINING_DAYS: "剩余金额必须在入住前支付",
    PAYMENT_WHEN_CHECKIN: "入住前支付",
    PAYMENT_WHEN_CHECKOUT: "退房前支付",
    VIEWDETAIL_PHOTO: "查看更多照片",
    PAYMENT_100: "支付100%的预订金额",
    CANCEL_100: "取消将收取100%的预订金额",
    FREE_DEPOSIT: "免押金",
    ARRIVAL_DATE: "入住日期",
    LEAVING_DATE: "离店日期",
    CHIlDRENTS: "儿童",
    CHIlDRENT: "儿童",
    ADULTS: "成人",
    FREE_CANCEL: "免费取消",
    CHARGE: "收取额外费用",
    CHARGE_AS_ADULTS: "按成人收费",
    CHILDREN_BELOW: "儿童低于",
    CHILDREN_OVER: "儿童超过",
    CHILDREN_FROM: "儿童从",
    AGES: "岁",
    DISCOUNT: "折扣",
    READ_MORE: "阅读更多",
    READ_LESS: "收起",
    PICTURE_FACILITIES: "照片与设施",
    CAPACITY: "容量",
    OPTIONS: "房型",
    ALL_CAPACITY: "查看所有设施",
    UN_ALL_CAPACITY: "收起",
    PAYMENT_BEFORE: "入住前支付",
    NO_PAYMENT_BEFORE: "无需预付款",
    BOOK_WITHIN: "预订时间",
    PAYMENT_100_NOW: "立即支付100%的预订金额",
    CANCEL_FREE_FROM: "免费取消预订时间从",
    TO_H: "先到先得",
    CANCEL_FREE_BEFORE: "在此之前无需取消费用",
    FROM: "从",
    UNTIL: "至",
    EARLY_CONFIRM: "提前确认！",
    SEND_REQUEST_BOOKING: "提交预订请求",
    SEND_REQUEST_CART: "添加请求",
    SEND_REQUEST_NOW: "立即发送请求",
    AREA_INFO: "区域信息",
    CANCELLATION_POLICY: "取消政策",
    CHILD_AND_BED: "儿童政策",
    IF_CANCELED_BEFORE: "取消前",
    THERE_ARE: "有",
    ROOM_TYPES_WITH: "房型有",
    OPTIONS_DETAIL: "房型详情",
    SPECIAL_OFFER: "特价优惠",
    HOTEL_POLICY: "酒店政策",
    CHECK_AVAILABILITY: "查询房间",
    PRICE_FOR: "价格为",
    ONLY: "仅",
    NIGHT: "晚",
    ROOM_LEFT: "剩余房间",
    THE_PRICE_DOES_NOT_INCLUDE_VAT: "价格不含税",
    SERVICE_CHARGE: "服务费",
    THE_PRICE_DOES_INCLUDE_VAT: "价格包含税费",
    THE_PRICE_DOES_NOT_INCLUDE_VAT_NOT_TOOL: "不包含税费",
    SERVICE_CHARGE_NOT_TOOL: "费用",
    THE_PRICE_DOES_INCLUDE_VAT_NOT_TOOL: "包含税费",
    ADD_ROOM: "添加房间",
    BOOK_NOW: "立即预订",
    AND_SERVICE_CHARGE: "以及服务费",
    AND_SERVICE_CHARGE_NOT_TOOL: "以及费用",
    NO_CHARGE: "无需费用",
    ADULTS_BTN_RESULTSEARCH: "成人",
    ABOVE_12_YEARS: "12岁以上",
    CHILDRENS_BTN_RESULTSEARCH: "儿童",
    BELLOW_12_YEARS: "12岁以下",
    ROOM: "房间",
    HOW_OLD_ARE_THE_CHILDRENT: "您同行的儿童几岁了",
    CHECKIN: "入住",
    CHECKOUT: "退房",
    T2: "周一",
    T3: "周二",
    T4: "周三",
    T5: "周四",
    T6: "周五",
    T7: "周六",
    T8: "周日",
    TH1: "一月",
    TH10: "十月",
    TH11: "十一月",
    TH12: "十二月",
    TH2: "二月",
    TH3: "三月",
    TH4: "四月",
    TH5: "五月",
    TH6: "六月",
    TH7: "七月",
    TH8: "八月",
    TH9: "九月",
    MOST_POPULAR: "最受欢迎的设施",
    EVERY_OPTION: "其他设施",
    GIFT_CODE: "折扣码",
    COPY_THIS_CODE: "复制此代码并粘贴到支付页面",
    ENDOW: "折扣",
    APPLY_FOR_MIN_ORDER_FROM: "适用于从最低订单起",
    APPLY_ON_TOTAL_ROOM_RATE: "适用于总房费",
    APPLY_ON_TOTAL_BOOKING: "适用于总预订金额",
    APPLY_ON_TOTAL_SERVICE: "适用于所有服务费用",
    APPLY_ALL_ORDER: "适用于每个订单",
    NO_ROOM_LEFT: "没有剩余房间",
    QUIT_FAVORITE: "已添加到收藏夹",
    SUM_PROMOTION: "累计促销",
    PRIORITY_PROMOTION: "优先促销",
    BEST_PROMOTION: "最佳促销",
    TYPE_PROMOTION: "促销设置",
    INDEX: "索引",
    PMS_SUCCESS: "恭喜，酒店已成功通过ezCrs完成一间房的销售",
    COMPLETE_INFOMATION: "完整信息",

    // Module Service
    SERVICE: {
        CONFIRM_DELETE_SERVICE: "您确定要删除吗？",
        CONFIRM_DEACTIVE_SERVICE: "您确定要停用吗？",
        SPECIAL_PRICE: "每日价格",
        SPECIAL_PRICE_TITLE: "日期",
        SPECIAL_PRICE_VALUE: "价格",
        ADD_SPECIAL_PRICE: "添加特殊日期价格",
        HAS_EXITS: "已存在",
        LINK: "链接列表",
        STATUS_SYNC: "同步状态",
        ORDER: "订单",
        THUMBNAIL: "图片",
        STATUS: "状态",
        DEACTIVE: "未激活",
        ACTIVE: "已激活",
        SYNC_PMS: "从PMS同步",
        LIST: "服务列表",
        INFO: "服务信息",
        NAME: "标题",
        DESCRIPTION_INFO: "描述",
        DESCRIPTION_INFO_DEFAULT: "描述",
        CODE: "服务代码",
        TIME_APPLY: "时间设置",
        DAY_APPLY: "一周中的天数",
        DAYS_NOT_APPLY: "不可用日期",
        ADD_DAYS_NOT_APPLY: "添加不可用日期",
        TIME_BOOK: "预订日期",
        TIME_USE: "使用日期",
        FREE: "免费服务",
        PREMIUM: "付费服务",
        PRICE: "价格",
        PRICE_STATUS: "服务费用",
        INCLUDE_TAX: "含税",
        CURRENCY: "货币",
        COPPY: "复制",
        UNIT: "单位",
        PER_BOOKING: "每次预订",
        PER_PERSON_PER_NIGHT: "每人每晚",
        PER_ROOM: "每房",
        PER_ROOM_PER_NIGHT: "每房每晚",
        PER_PERSON: "每人",
        TAX_LABEL: "税",
        MAXBOOK: "最大预订数量",
        PACKAGE_SELL: "价格计划",
        PACKAGE_ALL: "全部",
        PACKAGE_SPEC: "部分价格计划",
        SELL_CHANEL: "销售渠道",
        CHANEL_ALL: "应用于所有销售渠道",
        CHANEL_SPEC: "应用于部分销售渠道",
        CODE_MAX_LENGTH: "必须大于2个字符",
        SPECIAL_DESC: "特定日期的价格",
        NOT_EMPTY: "不能为空",
        ERROR_DUPLICATE_DAY: "日期重叠，请重新检查",
        TAX_DEFAULT: "默认",
        UPDATE_IMAGE_SUCCESS: "上传图片成功",
        UPDATE_IMAGE_FAIL: "上传图片失败",
        CANCEL: "取消",
        NOTHUMB: "照片不能为空",
        IMAGE_TOO_LARGE: "图片大小不得超过8MB",
        BINDING_PRICE: "包含在房价中",
        MAXQUATITY: "最大服务数量",
        UNLIMIT: "无限制",
        LIMIT: "限制",
        ONE_TIME: "一次性",
        CONFIRM_ACTIVE_SERVICE: "您确定要激活吗？",
        BENEFIT: "福利与实用性",
        MANDATORY_ADD_ON: "强制附加项",
        MANDATORY_ADD_ON_INFO: "如果选择此项，预订时将自动应用此服务。",
    },
    IMAGE_NOT_EXIST: "暂无照片",
    IMAGE_SERVICE: "照片",

    _ROOM_SALE: {
        ROOM_TYPE: {
            ROOM_TYPE: "房型",
            ROOM_CODE: "房间编码",
            MAX_PERSON: "最大入住人数",
            MAX_ADULT: "最大成人数",
            MAX_CHILD: "最大儿童数",
            MAX_KID: "最大婴儿数",
            ROOM_PARENT_TYPE: "父母房型",
            ERROR_ROOM_CODE: "房间编码不能重复或为空",
            ERROR_ROOM_PARENT: "您选择的房间已配置为当前房间的父母房型"
        },
        EXPAND: "显示更多",
        UNEXPAND: "显示更少",
        SELL_CHANNEL: "渠道",
        SELL_MARKET: "市场",
        SELL_CHANNEL_ALL: "所有渠道",
        SELL_CHANNEL_SPEC: "部分渠道",
        SELL_MARKET_ALL: "所有市场",
        SELL_MARKET_SPEC: "部分市场",
        LABEL_SEARCH_CODE_NAME: "编码/房型",
        ENTER_HOTEL_NAME_OR_CODE: "请输入编码/房型"
    },
    _SALE_PACKAGE: {
        SALE_PACKAGE: "价格计划",
        ADD_NEW: "添加新价格计划",
        ENTER_SALE_PACKAGE_NAME_OR_CODE: "请输入编码/价格计划",
        RATE_CATEGORY: "价格类别",
        RATE_CATEGORY_ADD_NEW: "添加新价格类别",
        ROOM_CATEGORY: "房间类别",
        ROOM_CATEGORY_ADD_NEW: "添加新房间类别"
    },
    ADD_NEW_ROOM: "添加新房间",
    ROOMS_PER_PAGE: "每页显示房间数",
    NOT_EMPTY: "请输入值",
    _SERVICE_PACKAGE: {
        AGE_MAX_CHILD: "最大儿童年龄",
        AGE_MAX_BABY: "最大婴儿年龄",
        DAY_APPLY_IN_WEEK: "一周中的适用天数",
        PAYMENT_POLICY: "支付政策",
        CANCEL_POLICY: "取消政策",
        APPLY_OBJECT: "适用对象",
        APPLY_CARD: "卡类型",
        PACKAGE_CODE: "价格编码",
        ADD_PAYMENT_POLICY: "添加支付政策",
        ADD_CANCEL_POLICY: "添加取消政策",
        SALE_PACKAGE_CODE: "价格编码",
        ERROR_SALE_PACKAGE_CODE: "价格编码不能重复或为空"
    },
    PACKAGE_PER_PAGE: "每页套餐数",
    ADD_RANGE_DAYS_NOT_APPLY: "添加停用日期",
    NOT_APPLY_RANGE_DATE: "停用日期",
    ROOM_AVAILABLE: "库存",
    NO_ROOM_PARENT: "无",
    ROOM_RATE: "房价",
    ADD_SALE_PACKAGE: "添加价格计划",
    ADD_DATE_RANGE: "添加日期范围",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE: "确认删除日期范围吗？",
    SELECT_SALE_PACKAGE: "选择价格计划",
    LIST_SALE_PACKAGE_EMPTY: "价格计划列表为空",
    VIEW_TABLE: "查看表格",
    VIEW_CALENDAR: "查看日历",
    SELECT_ROOM_TO_VIEW: "请选择房间查看",
    SHOW_ROOM_AVAIL: "显示可用数量",
    ROOM_CONNECTED_OTA: "房间已同步OTA",
    RESTRICTION_PACKAGE: "限制套餐",
    RESTRICTION: "限制",
    ENTER_RESTRICTION_NAME_OR_CODE: "输入限制名称或代码",
    CONFIRM_DELETE_RESTRICTION: "确认删除限制套餐",
    RESTRICTION_INFOMATION: "限制信息",
    CONFIG_RESTRICTION: "限制配置",
    DEFAULT: "默认",
    ROOMTYPE: "房型",
    ROOMPLAN: "价格计划",
    RESTRICTION_NAME: "限制名称",
    ADD_NEW_RESTRICTION: "添加新限制",
    METADATA: "选择更新",
    RESTRICTION_BULK_UPDATE: "批量更新",
    RESTRICTION_BULK_DELETE: "批量删除",
    ROOM_AVAIL: "库存",
    SELL_LIMIT: "销售限制",
    STOP_SELL_LIMIT: "停止销售限制",
    PRICE: "房价",
    MANAGE_SYNC_OTA: "渠道同步",
    MANAGE_ALIAS_OTA: "ezCms Vela",
    ALL_ROOM: "所有房间",
    NOT_SELECT_SALE_PACKGE: "请选择价格计划",
    DATA_INPUT_INVALID: "数据无效",
    UPDATE: "更新",
    SELECT_ROOM_APPLY: "选择房型",
    SELECT_SALE_PACKAGE_APPLY: "选择价格计划",
    SPECIAL_PRICE: "每日价格",
    ENTER_PRICE_AND_CHOSE_SALE_PACAKGE: "价格，价格计划为空",
    minStay: "最短入住",
    maxStay: "最长入住",
    minStayArrival: "最短到达天数",
    maxStayArrival: "最长到达天数",
    minBookingWindow: "最短预定窗口",
    maxBookingWindow: "最长预定窗口",
    minBookingWindowByHour: "最短预定窗口（小时）",
    maxBookingWindowByHour: "最长预定窗口（小时）",
    exactStay: "准确入住",
    exactStayArrival: "准确到达",
    fromCheckout: "从退房开始",
    cutOfTime: "截止时间",
    closedOnArrival: "到达时停止销售",
    closedOnDeparture: "离开时停止销售",
    closed: "停止销售",
    belongTo: "属于",
    appliedFor: "已应用",
    CHANNEL_APPLY: "渠道",
    CHANNEL_EMPTY: "空渠道",
    APPLY_FOR: "适用",
    priceExtraAdult: "额外成人费用",
    priceExtraChild: "额外儿童费用",
    priceExtraBaby: "额外婴儿费用",
    DAY_SPECIAL: "每日价格",
    SUN_SHORT: "周日",
    MON_SHORT: "周一",
    TUE_SHORT: "周二",
    WED_SHORT: "周三",
    THU_SHORT: "周四",
    FRI_SHORT: "周五",
    SAT_SHORT: "周六",
    JAN_SHORT: "一月",
    FEB_SHORT: "二月",
    MAR_SHORT: "三月",
    APR_SHORT: "四月",
    MAY_SHORT: "五月",
    JUN_SHORT: "六月",
    JUL_SHORT: "七月",
    AUG_SHORT: "八月",
    SEP_SHORT: "九月",
    OCT_SHORT: "十月",
    NOV_SHORT: "十一月",
    DEC_SHORT: "十二月",
    NO_SELECT: "无变化",
    OPEN: "开启",
    CONFIRM_DELETE_SPECIAL_PRICE: "确认删除每日价格",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_ADULT: "确认删除每日额外成人费用",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_CHILD: "确认删除每日额外儿童费用",
    CONFIRM_DELETE_SPECIAL_PRICE_EXTRA_BABY: "确认删除每日额外婴儿费用",
    REMOVE_SPECIAL_PRICE: "删除每日价格",
    NO_DATA: "没有数据",
    CURRENCY_OTA: "渠道货币",
    ROOM_TYPE_ON_OTA: "渠道房型",
    SALE_PACKAGE_ON_OTA: "渠道价格计划",
    NUMBER_OF_PERSON: "人数",
    PACKAGE_TYPE: "套餐类型",
    RATES: "房价",
    RATES_OSCILLATE: "额外费用",
    REGULAR_PRICE: "常规价格",
    SYNCED: "已同步",
    ROOM_CLOSED: "关闭",
    NO_SALEPACKAGE_AVAIL: "价格计划不可用",
    YES: "是",
    NO: "否",
    BOOKING_CUSTOMER_NAME: "客户姓名",
    BOOKING_EMPTY: "未找到预订。",
    BOOKING_CHANNEL: "渠道",
    BOOKING_HOTEL: "酒店",
    STT: "编号",
    BOOKING_IS_NOT_EXIST: "预订不存在",
    ADD_NEW_SALE_CHANNEL: "添加新渠道",
    CONNECT: "连接",
    SELECT_SALE_CHANNEL: "选择渠道",
    PHONE_INVALID: "电话无效",
    EMAIL_INVALID: "电子邮件无效",
    LOGIN_NOW: "立即登录！",
    POLICY_NAME: "政策名称",
    POLICY_DESCRIPTION: "政策描述",
    DESCRIPTION: "描述",
    APPLY_DAY: "适用",
    DEPOSIT_UNIT: "单位",
    APPLY_FOR_STAYING: "按入住日期",
    APPLY_FOR_BOOKING: "按预订日期",
    CHECKOUT_DATE: "退房日期",
    CHECKIN_DATE: "入住日期",
    BEFORE_CHECKIN_DATE: "入住前",
    BEFORE_CHECKOUT_DATE: "退房前",
    CANCEL_ROOM_IN_ROUND_X_DAY_BEFORE: "在x天内取消预订",
    NIGHT_CAP: "0晚 | 1晚 | {count}晚",
    CHANGE_PASSWORD_REQUEST_NO_LONGER_WORK: "您的密码更改请求已失效！",
    MAXROOM_1000: "最大房间数为1000",
    DATA_INPUT_MAX_100_PERCENT: "最大值为100",
    DATA_INPUT_MAX_10_NIGHT: "最大值为10晚",
    DUPLICATE_CODE: "代码重复",
    CREATE: "创建",
    BULK_UPDATE: "批量更新",
    SETUP_OTA: "设置OTA",
    AUTH: "访问酒店",
    RECEIVE_BOOKING_FROM_OTA: "接收OTA预订",
    UPDATE_INVENTORY: "从PMS更新库存",
    RECEIVE_INVENTORY_UPDATE_FROM_PMS: "接收PMS库存更新到OTA",
    PUSH_BOOKING_NOTIFICATION_TO_PMS: "推送预订通知到PMS",
    HOTEL_INFO: "酒店信息",
    HOTEL_IMAGE: "酒店图片",
    HOTEL_AREA: "酒店区域",
    HOTEL_AMENITY: "酒店设施",
    HOTEL_CANCELLATION_POLICY: "酒店取消政策",
    HOTEL_SETTING: "酒店设置",
    HOTEL_PAYMENT_POLICY: "酒店支付政策",
    SETUP_AND_MAPPING_TO_OTA: "设置和映射到OTA",
    HOTEL_RATE_PLAN: "酒店价格计划",
    HOTEL_RESTRICTION: "酒店限制",
    HOTEL_ROOM_TYPE: "酒店房型",
    HOTEL_ROOM_TYPE_AMENITY: "酒店房型设施",
    HOTEL_ROOM_TYPE_AVAILABILITY: "酒店房型可用性",
    HOTEL_ROOM_RATE: "房间价格",
    HOTEL_ROOM_TYPE_STOP_SELL: "酒店房型停止销售",
    HOTEL_ROOM_RATE_ADULT: "酒店成人房价",
    HOTEL_ROOM_RATE_CHILD: "酒店儿童房价",
    HOTEL_ROOM_RATE_BABY: "酒店婴儿房价",
    HOTEL_ROOM_RATE_SPECIAL: "酒店特价房价",
    STAFF_INFO: "员工信息",
    STAFF_PASSWORD: "员工密码",
    STAFF_AVATAR: "员工头像",
    STAFF_LOGIN: "员工登录",
    HOTEL_REGISTER: "酒店注册",
    CHANGE_STATUS: "更改状态",
    LOG_ACTION: "操作",
    LOG_FUNCTION: "功能",
    LOG_CONTENT: "日志",
    LOG_DATE_CREATE: "创建日期",
    LOG_USERNAME: "用户名",
    PRICE_ON_OTA: "OTA上的价格",
    PRICE_ON_DEFINED: "声明的价格",
    STOP_SELL_TRIGGER: "停止销售触发",
    DOWNLOAD: "下载",
    CONFIRM_CHANGE_STATUS_SALE_PACKAGE: "价格计划已同步到OTA，您确定要更改状态吗？",
    CONFIRM_CHANGE_STATUS_ROOMTYPE: "房型已同步到OTA，您确定要更改状态吗？",
    hotel_id: "酒店ID",
    property_id: "房产ID",
    // OTA_hotel_id: "ID Khách sạn",
    HOTEL_ROOM_TYPE_IMAGES: "房间图片",
    IMAGE_MANAGAMENT: "图库",
    UNIT: "单位",
    NEARBY_TYPE: "附近类型",
    DIALOG_CONFIRM_DESC: "是否根据房价计划配置进行有限更新？",
    CANNOT_GET_INFO_FROM_OTA_1: "与OTA的通信中断。",
    CANNOT_GET_INFO_FROM_OTA_2: "请通过1900 9013或发送电子邮件至hotro@ezcloud.vn与我们联系。",
    ROOMTYPE_HAS_NO_RATEPLAN: "请填写已配置的房型、房价计划和渠道组合。",
    MAX_LENGTH_10: "数据限制为10个字符",
    UPDATE_BY: "更新者",
    OTA_HAS_NO_RATEPLAN: "此OTA尚未配置房价计划。",
    PRICE_IS_REQUIRED: "价格为空",
    HOTEL_ROOM_IS_OVER_LIMIT: "酒店房间超出限制",
    CONFIRM_DELETE_PROMOTION: "您确定要删除促销吗？",
    ADD_NEW_PROMOTION: "添加新促销",
    ADD_NEW_SERVICE: "添加新服务",
    PRICE_EXTRA: "额外费用",
    PERSON_NUMBER: "人数",
    DETAIL: "详情",
    PRICE_AND_PERSON_IS_REQUIRED: "价格和人数是必填项",
    CHOOSE_LANG_PAYMENT: "选择付款方式语言",
    ENTER_CONTENT_SHOW: "请输入要显示的内容",
    CONFIG_BE: "预订引擎",
    SAVE_SUCCESS: "保存成功",
    CONFIGURE_OUGING_EMAIL: "已发送电子邮件",
    EMAIL_SEND: "电子邮件地址",
    EMAIL_NAME_SEND: "显示名称",
    SERVER_MAIL_ADDRESS: "SMTP服务器",
    CONNECTOR: "SMTP端口",
    ENCRYPTION_TYPE: "安全连接",
    AUTHENTICATON_CONNECTION: "身份验证连接",
    EMAIL_TYPE: "电子邮件类型",
    TEST_EMAIL_SENT: "测试外发电子邮件",
    SENT_EMAIL_TEST: "发送测试电子邮件",
    EMAIL_SETTING_EXISTED: "电子邮件已存在",
    ERROR_MAIL: "错误",
    SUCCESS_MAIL: "电子邮件发送成功",
    UNIT_ROOM_PRICE: "房价",
    FROM_CHECKOUT: "从退房开始",
    NON_REFUNDABLE: "不可退款",
    GUEST_NAME: "客人姓名",
    FROM_TIME: "从",
    TO_TIME: "至",
    PROMOTION_CODE: "促销代码",
    SORT: "排序",
    HAS_CONNECTED: "已连接",
    GUEST: "客人",
    COUPON_CODE: "优惠券代码",
    PAYMENT_REQUIRED_UPON_BOOKING: "预订时要求付款",
    CONDITIONS: "条件",
    HOW_MUCH_PAYMENT_IS_MADE_BY_THE_GUEST_ON_THE_DAY_OF_BOOKING: "客人预订当天支付了多少款项？",
    PERCENT_OF_TOTAL_ROOM_RATE: "总房费的百分比",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT_FOR_THE_REMAINING_AMOUNT: "客人何时支付剩余款项？",
    WHAT_THE_PAYMENT_POLICY_FOR_THE_BOOKING_PERIOD: "支付政策适用于哪个设定的期间？",
    WHAT_DOES_PAYMENT_POLICY_APPLY: "支付政策适用于哪个住宿期间？",
    POLICY_SUMMARY: "政策总结",
    PERCENT_BOOKING: "预订百分比",
    WHEN_DOES_THE_CUSTOMER_MAKE_THE_PAYMENT: "客人何时付款？",
    DATA_INPUT_MAX_24_HOUR: "数据不能超过24小时",
    DAY: "日期",
    HOUR: "小时",
    HOW_MUCH_DOES_THE_CUSTOMER_MAKE_PAYMENT: "客人已支付多少款项？",
    ON_THE_DAY_OF_CHECK_IN: "在入住日期",
    ON_THE_DAY_OF_CHECK_OUT: "在退房日期",
    PRICE_PER_NIGHT: "每晚房价",
    ON_THE_DATE_OF_BOOKING: "在预订日期",
    UPDATE_PRICE_NOTE: "价格和数量数据已被覆盖。主房型的房价更新将影响子房型的房价。",
    PROMOTION_TITLE: "标题",
    FREE_CANCELLATION_ALLOWED: "允许免费取消",
    HOW_LONG_BEFORE_CHECK_IN_CAN_GUESTS_CANCEL_FOR_FREE: "在入住前多久客人可以免费取消？",
    DAY_BEFORE_CHECK_IN: "入住前{day}天",
    ACCORDING_TO_CUSTOM: "自定义",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_THEY_CANCEL_A_RERVATION_DAYS_PRIOR_TO_ARRIVAL: "客人提前{day}天取消预订时需支付多少费用？",
    HOW_MUCH_DO_GUESTS_HAVE_TO_PAY_WHEN_CANCELING_A_RESERVATION: "客人取消预订时需要支付多少费用？",
    WHAT_THE_CANCEL_POLICY_FOR_THE_BOOKING_PERIOD: "取消政策适用于哪个期间？",
    WHAT_DOES_CANCEL_POLICY_APPLY: "取消政策适用于何时？",
    HOW_MUCH_WILL_THE_CUSTOMER_HAVE_TOT_PAY_IF_THE_GUEST_CANCELS_ON_THE_CHECKIN: "如果客人在入住当天取消预订，客户需要支付多少费用？",
    UTC: "时区",
    ROOM_ARE_AVAILABLE_FROM_LESS_TO_MORE: "房间从少到多可用",
    TIME_ZONE_HOTEL: "酒店时区",
    BED_TYPE_SETTING: "床型设置",
    ROOM_TYPE_SETTING: "房型设置",
    OVER_MAX_GUEST: "房型未满足最大入住人数",
    OVER_MAX_ADULTS: "房型未满足最大成人人数",
    OVER_MAX_CHILDREN: "房型未满足最大儿童人数",
    OVER_MAX_BABY: "房型未满足最大婴儿人数",
    UNDER_MAX_ADULTS: "销售包未满足最大成人人数",
    UNDER_MAX_CHILDREN: "销售包未满足最大儿童人数",
    UNDER_MAX_BABY: "销售包未满足最大婴儿人数",
    UNDER_MAX_QUANTITY: "房间总数不能超过声明的可用房数",
    BOOKING_ENGINE: "预订引擎",
    TEXT_NOTIFY_EXPIRED: "您的账户与{channel}渠道的分销通道连接已于{date}过期，数据将无法同步到OTA渠道，请续费。",
    TEXT_NOTIFY_WILL_EXPIRE: "您的账户与{channel}渠道的分销通道将于{date}过期，数据将无法同步到OTA渠道，请续费。",
    ROOM_AND_PACKAGES_FOR_SALE_ON_GOOOGLE: "在Google酒店渠道上销售的房间和套餐",
    HOTEL_LOG_roomTypeI18n: "房型",
    HOTEL_LOG_lang: "语言",
    HOTEL_LOG_ratePlanI18n: "房价套餐",
    HOTEL_LOG_otaI18n: "OTA",
    BE_CONNECT_REQUIRED: "尚未连接预订引擎",
    ACCESS_DENIED: "没有访问权限",
    OTA_NOT_FOUND: "未找到OTA",
    HOTEL_SYNC: "酒店已同步",
    PASSWORD_SENT_SUCCESS: "密码发送成功",
    CAN_NOT_DELETE: "房型/销售套餐已连接至OTA，无法删除",
    BOOKING_NOT_CANCEL: "无法取消预订",

    HEADER_FOOTER_CONFIG: "模板",
    MENU_EDIT: "菜单类型",
    MENU_NAME: "名称",
    MENU_CONFIG: "菜单显示",
    WIDGETS_EDIT: "小部件类型",
    ADD_NEW_WIDGETS: "添加新小部件",
    WIDGETS_NOT_YET_DISPLAYED: "小部件尚未显示",
    PARAMETERS: "其他设置",
    LOGO_DISPLAYS: "URL徽标",
    TOP_HEADER_BACKGROUND: "顶部标题 – 背景颜色",
    HEADER_BACKGROUND: "标题 – 背景颜色",
    TEXT_HEADER_COLOR: "标题 – 文本颜色",
    TEXT_HEADER_COLOR_ACTIVE: "主色",
    FOOTER_BACKGROUND: "页脚 – 背景颜色",
    TEXT_FOOTER_COLOR: "页脚 – 文本颜色",
    BACKGROUND_COPYRIGHT: "页脚底部 – 背景颜色",
    ADD_NEW_MENU: "添加新菜单",
    CONTENT_WIDGETS: "内容",
    TITLE: "标题",
    REFERENCE_SAMPLE: "参考示例",
    VI: "越南语",
    EN: "英语",
    BIGGER_THAN_EQUAL: "大于等于",
    AND_MORE: "和{count}个其他选项",
    ALL_AGENT: "所有代理",
    GROUP_AGENT: "代理组",
    SPECIFIC_AGENT: "特定代理",
    CHOOSE_NOT_APPLY_AGENT: "选择不适用促销的代理商",
    CHOOSE_APPLY_AGENT: "选择适用促销的代理商",
    LIST_NOT_APPLY_AGENT: "不适用促销的代理商列表",
    LIST_APPLY_AGENT: "适用促销的代理商列表",
    SEARCH_NAME_AGENT: "输入代理商名称或代码",
    AGENT_TYPE: "类型",
    ENTERPRISE_AGENT: "企业旅行",
    ENTERPRISE_TRADING: "企业交易",
    ENTERPRISE_API: "企业API",
    LIST_AGENT: "旅行代理商列表",
    SUCCESS: "成功",
    CONFIG_CONNECT: "配置连接",
    NO_RECORDS: "没有记录可显示",
    QUANTITY: "数量",
    ROOM_PRICE: "房价",
    EXTRA_ADULT: "额外成人",
    EXTRA_CHILD: "额外儿童",
    HOTEL_PROMOTION: "酒店促销",
    GUEST_INFO: "客户信息",
    MAX_GUEST: "最大人数",
    MAX: "最大",
    BOOKING_INFO: "基本信息",
    WRONG_DOMAIN: "无效的域名",
    FILE_NULL: "上传文件错误",
    PLEASE_COMPLETE_THE_FIELDS_MARKED: "请填写所有必填信息",
    ADD_NEW_SOCIAL_NETWORK: "添加社交网络",
    PRIMARY_TEXT_COLOR: "主要文本颜色",
    PRIMARY_BACKGROUND_COLOR: "主要背景颜色",
    TOP_HEADER_TEXT_COLOR: "顶部标题文本颜色",
    TOP_HEADER_BACKGROUND_COLOR: "顶部标题背景颜色",
    HEADER_TEXT_COLOR: "标题文本颜色",
    HEADER_BACKGROUND_COLOR: "标题背景颜色",
    FOOTER_TEXT_COLOR: "页脚文本颜色",
    FOOTER_BACKGROUND_COLOR: "页脚背景颜色",
    BOTTOM_FOOTER_TEXT_COLOR: "底部页脚文本颜色",
    BOTTOM_FOOTER_BACKGROUND_COLOR: "底部页脚背景颜色",
    BUTTON_TEXT_COLOR: "按钮文本颜色",
    BUTTON_BACKGROUND_COLOR: "按钮背景颜色",
    BUTTON_TEXT_COLOR_2: "按钮文本颜色 2",
    BUTTON_BACKGROUND_COLOR_2: "按钮背景颜色 2",
    CUSTOM: "自定义",
    URL: "链接",
    OTA_IS_OUT_OF_TIME: "OTA渠道尚未激活",
    DATA_INPUT_MUST_BE_GREATER_THAN_0: "输入数据必须大于0",
    HOTEL_EXTRA_RATE_UPDATE: "更新附加费率",
    HOTEL_EXTRA_RATE_DELETE: "删除附加费",
    DATE_OF_STAY_DOES_NOT_APPLY: "入住日期不适用",
    DATE_OF_BOOKING_DOES_NOT_APPLY: "设置日期不适用",
    BOOKING_CODE_OTA: "OTA预订代码",
    HOTEL_WAS_CONNECTED_WITH_OTA: "酒店已连接至OTA渠道",
    ROOM_TYPE_OTA: "ezCms Leo",
    CONNECTED: "已连接",
    NOT_CONNECTED: "未连接",
    MISSING_ROOM_AND_PRICE: "缺少房间、价格和限制",
    CONNECTED_OTA: "OTA映射",
    SYNC_IN_PROGRESS: "正在同步",
    CONNECTING: "正在连接",
    ROOM_AND_PRICE_PACKAGES_HAVE_NOT_BEEN_DECLARED: "房间套餐和价格尚未声明",
    CONNECTION_FAILED: "连接失败",
    SU_CONNECTION: "销售渠道",
    SU_MAPPING: "映射",
    CHANNEL_MANAGER_SYSTEM: "中央预订系统",
    ENTER_NAME_OR_CODE: "输入代码或名称",
    OTA_LOG: "同步日志",
    INVENTORY_LOG: "库存日志",
    ERROR_LOG: "错误日志",
    SOURCE: "来源",
    UPDATE_TIME: "更新时间",
    RATE: "房价",
    STOP_SELL: "停止销售",
    MIN_STAY: "最短住宿日期",
    MAX_STAY: "最长住宿日期",
    EXTRA_ADULT_RATE: "额外成人收费",
    EXTRA_CHILD_RATE: "儿童附加费",
    FULL_UPDATE: "详情",
    UN_STOP_SELL: "取消停止销售",
    OPEN_RESERVATION: "开放预订",
    OPEN_CHECKOUT: "开放退房",
    ERROR_PHONE_NUMBER_LENGTH: "电话号码长度必须至少为6个字符，最多为10个字符",
    ERROR_PHONE_NUMBER_STRING: "电话号码不能包含字母，且不能以0开头",
    FAILURE: "失败",
    ACTIVE_LOG: "活动日志",
    WAITING: "进行中",
    ROOM_SALE_UPDATE: "更新销售房间",
    PRICE_EXTRA_SPECIAL: "每日附加费用",
    BASE_PRICE_IS_MISSING: "未声明基础价格",
    TOOLTIP_MASTER: "选择一个主产品线作为计算其余产品线价格的基础",
    RULE_CODE: "代码应为2-20个字符，仅包含字母和数字",
    ROOM_DERIVE: "派生房间 - 从父房型派生",
    DERIVE_OF_ROOM: "派生自",
    COPY_BY_FOMULAR: "按公式复制",
    PASTE: "粘贴",
    DATE_RANGE: "关于天数",
    CODE_IS_EXISTED: "服务代码已存在",
    HOTEL_CHANGE_SUCCESS: "酒店更改成功",
    ROOM_CLASS: "房型",
    UPDATE_FOR: "更新于 {date}",
    UPDATE_RATE_BY_RANGE: "批量更新",
    BOOKER: "预订人名称",
    SEARCH_BY_BOOKER: "客人姓名",
    CONTACT_US: "联系我们",
    UPDATE_TO_STOP_SELLING_OPENING: "更新为停止销售/开放销售",
    UPDATE_ROOM_AVAILABILITY_IN_STAGES: "批量更新",
    UPDATE_SELLING_PRICES_IN_STAGES: "更新价格",
    UPDATE_STOP_SELL: "更新停止销售",
    UPDATE_SELL_LIMIT_BY_OTA: "更新销售限制",
    UPDATE_SELL_LIMIT_FOR_NEW_OTA: "更新销售限制",
    UPDATE_RESTRICTION_STOPSELL: "更新停止销售限制",
    UPDATE_STOP_SELL_BY_OTA: "更新停止销售",
    DELETE_SELL_LIMIT_BY_OTA: "删除销售限制",
    DELETE_STOP_SELL_BY_OTA: "删除停止销售",
    OTHER_FUNCTION: "其他功能",
    VIEW_MOBILE_VERSION: "以移动设备查看",
    VIEW_DESKTOP_VERSION: "以桌面版本查看",
    FILTER_RESULTS: "筛选结果",
    STOPSELL_UPDATE_SUCCESS: "停止销售更新成功",
    REMOVE_STOPSELL_SUCCESS: "成功移除停止销售",
    HOTEL: "0 酒店 | 1 酒店 | {count} 酒店",
    NIGHT_NUMBER: "房夜",
    CONFIRM_STOP_SELL: "确认更新停止销售",
    CONFIRM_REMOVE_STOP_SELL: "确认移除停止销售",
    APP: "应用",
    ENTER_THE_NAME_OF_THE_APP_WANT_TO_SEARCH_FOR: "输入您要搜索的应用名称",
    LABEL_NIGHT_BACKGROUND_COLOR: "子背景颜色1",
    LABEL_NIGHT_TEXT_COLOR: "子文本颜色1",
    PACKAGE_TEXT_COLOR: "售卖套餐文本颜色",
    PROMOTION_BACKGROUND_COLOR: "二级背景颜色2",
    PROMOTION_TEXT_COLOR: "二级文本颜色2",
    PRICE_TEXT_COLOR: "价格文本颜色1",
    RANK_STAR_COLOR: "星级颜色",
    TEXT_PRICE_2_COLOR: "费用颜色2",
    SUB_TEXT_3_COLOR: "附加文本颜色3",
    SUB_BACKGROUND_3_COLOR: "子背景颜色3",
    RE_SYNC: "重新发布预订",
    CONFIRM_RE_SYNC: "确认重新发布",
    HOTEL_REPORT_BOOKING: "重新发布预订",
    UPDATE_INTERVAL_IS_NOT_MORE_THAN_ONE_YEAR: "更新间隔不得超过一年",
    ACCOUNT_IS_NOT_CONNECTED_TO_GDS: "账户尚未连接至ezCms GDS",
    DISCONNECT: "断开连接",
    CONFIRM_DISCONNECT_OTA: "您确定要断开连接吗",
    CONFIRM_CONNECT_OTA: "您确定要重新连接吗",
    GDS_OTA: "ezCms GDS",
    ROOM_DUPLICATE: "房间代码不能重复",
    ROOM_PLAN_DUPLICATE: "价格代码不能重复",
    YOU_DONT_HAVE_ANY_HOTELS_YET: "未找到任何酒店。",
    TEXT_GDS_INFOMATION: "GDS是一个全球计算机化预订网络，拥有超过45万个旅行社用于预订酒店房间。",
    ROOM_TYPE_ON_CMS: "ezCrs上的房型",
    ROOM_TYPE_ON_SABRE: "销售渠道上的房型",
    ROOM_PLAN_ON_CMS: "ezCrs上的房价套餐",
    ROOM_PLAN_ON_SABRE: "销售渠道上的房价套餐",
    CHAIN_CODE: "酒店链代码",
    CHAIN_TYPE: "酒店链类型",
    ITEMS_SHOWING: "显示项目",
    TA_NAME: "代理商名称",
    TA_CODE: "代理商代码",
    CHAIN_TRAVEL_AGENT_INFOMATION: "代理商信息",
    ASSIGN_TA_TO_HOTEL: "分配旅行代理商至酒店",
    ALLOW_OVERWRITING_INFOMATION_DOWN_TO_THE_HOTEL: "允许覆盖下传至酒店的信息",
    FIRST_NAME: "名字",
    LAST_NAME: "姓氏",
    CHAIN_AGENT_LIST: "公司和代理商",
    ASSIGN_ROOM_TO_HOTEL: "分配房间至酒店",
    ASSIGN_RATE_PLAN_TO_HOTEL: "分配房价套餐至酒店",
    CHAIN: "链",
    UNASSIGN: "未分配",
    ASSIGN: "已分配",
    CONFIRM_CHANGE_ACTIVE: "确认代理商状态更改",
    ENTERPRISE_CODE: "企业代码",
    FIRST_NAME_REPRESENT: "代表姓氏",
    LAST_NAME_REPRESENT: "代表名字",
    ACCOUNT_HOLDER: "账户持有人",
    POSITION: "职位",
    HOTEL_LIST: "酒店列表",
    CHAIN_CONFIG: "链配置",
    ASSIGN_SERVICE_TO_HOTEL: "分配服务到酒店",
    ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "酒店房型已同步，请再次检查",
    ROOM_CODE_DUPLICATION_ROOM_CODE_IN_CHAIN: "房型代码与字符串房型代码匹配，请检查",
    ROOM_CODE_DUPLICATION: "房型代码已存在",
    CHAIN_ROOM_TYPE_IS_OVER_LIMIT: "房间数量超过酒店层级的房间总数",
    RATE_PLAN_CODE_DUPLICATION: "销售套餐已存在，请检查",
    SERVICE_NOT_EXIST: "服务不存在",
    SERVICE_CODE_DUPLICATION: "服务代码在链酒店中已存在，请检查",
    TRAVEL_AGENT_ALREADY_EXIST: "公司信息、代理商已存在，请检查",
    HOTEL_NOT_USE_EQUAL_CURRENCY: "分配的酒店使用不同货币，请检查",
    AUTO_CANCEL: "如果预订未确认，允许自动取消",
    ACCOUNT_IS_NOT_CONNECTED_TO_SITEMINDER: "账户未连接至ezCms SiteMinder",
    ACCOUNT_IS_NOT_CONNECTED_TO_TRAVELOKA: "账户未连接至ezCms Traveloka",
    ROOM_TYPE_MAP_UNMAP: "当前连接的房型如果取消选择并保存，将断开连接，可能会导致连接丢失、超售或预订失联",
    OTA_HOTEL_CODE_ALREADY_EXITS: "您输入的酒店代码已连接，请检查",
    ADD_SERVICE_TO_ROOM_RATE: "将服务添加到销售套餐",
    CONFIRM_DELETE_SERVICE_PACKAGE: "确认从房价中删除此服务",
    PACKAGE_DEAL: "套餐优惠",
    PACKAGE_ITEM: "套餐项目",
    PRICE_ALLOCATION: "价格分配",
    WEEKLY_PRICE: "每周价格",
    DAILY_PRICE: "每日价格",
    RD_DAY: "{day}号",
    TOTAL_PACKAGE_VALUE: "套餐总价值",
    LIST_EDIT_SUCCESS: "更新成功",
    INFOMATION_OF_BANK_ACCOUNT: "银行账户信息",
    CHILD_HAS_MORE_OTA_THAN_MASTER: "无法创建关系",
    ENTIRE_HOTEL: "酒店级别",
    ACCORDING_TO_EACH_ROOM_CLASS: "房型级别",
    NUMBER_OF_ROOMS_AVAILABLE: "可用房间数量",
    ROOM_OCCUPANCY: "房间入住率",
    EDIT_DYNAMIC_PRICING: "动态定价模板详情",
    ADD_NEW_DYNAMIC_PRICING: "添加新的动态定价模型",
    DYNAMIC_PRICING: "动态定价",
    CONFIRM_DELETE_DYNAMIC_PRICING: "确认删除动态定价模型",
    DYNAMIC_NAME: "动态定价模型名称",
    DYNAMIC_DESCRIPTION: "动态定价模型描述",
    CRITERIA: "标准",
    PRICE_CALCULATION_FORMULA: "价格计算公式",
    TOTAL_NUMBER_OF_ROOMS_BY_ROOM_CLASS: "按房型统计的已售房间总数（包括日用预订的房间）",
    TOTAL_NUMBER_OF_ROOMS_BY_HOTEL: "按酒店统计的已售房间总数（包括日用预订的房间）",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_ROOM_CLASS: "按房型统计的可用房间总数",
    TOTAL_NUMBER_OF_AVAILABLE_ROOMS_BY_HOTEL: "按酒店统计的可用房间总数",
    ROOM_CAPACCITY_FORMULA: "房间容量公式",
    FROM_TO_LESS: "从{val}到小于",
    NO_PRIOTITY: "无优先级",
    PRIOTITY: "优先级",
    UN_SELECT_ALL: "删除",
    SET_THE_PRICE_CYCLE: "动态销售",
    EVENT: "按事件",
    CALENDAR: "日程安排（即将推出）",
    DYNAMIC_RATE_METHOD: "动态定价方法",
    CONFIRM_DEACTIVE_DYNAMIC_RATE: "确认停用动态定价",
    RMS_MANAGEMENT: "收益管理",
    DERIVED_ROOMTYPE: "派生房型",
    BASE: "基础房型",
    UPDATE_FORMULAR: "更新公式",
    FORMULAR: "公式",
    SET_UP_FORMULAR_BY_DATE_RANGE: "按日期范围设置公式",
    MASTER_RATE: "主定价",
    SET_UP_FORMULAR: "设置公式",
    CONFIRM_DELETE_FORMULA: "确认删除公式",
    EDIT_PRICE: "编辑价格",
    FOR_EXAMPLE_SERVICE: "例如服务：<br> 预订日期从10月1日到10月10日（9晚）<br> 使用自定义配置：<br> <ul><li> 从第1晚开始：1 </li><li> 结束于第X晚：最后一晚 </li><li> 使用周期：2（天）</li><li> 重复次数：3（次）</li></ul> 服务可以从10月1日到10月10日应用。<br> 因为使用周期为2（2天/次），服务将应用于10月1日、3日、5日、7日和9日。<br> 由于重复次数为3，服务将应用于10月1日、3日和5日。",
    SCHEDULINGTYPE_1: "适用于入住的第一晚",
    SCHEDULINGTYPE_2: "适用于入住的最后一晚",
    SCHEDULINGTYPE_3: "X晚适用1次，从Y晚开始",
    SCHEDULINGTYPE_4: "适用于除第一晚外的所有晚",
    SCHEDULINGTYPE_5: "适用于除最后一晚外的所有晚",
    SCHEDULINGTYPE_6: "不适用于第一晚和最后一晚",
    SCHEDULINGTYPE_7: "适用于夜晚（14晚）",
    SCHEDULINGTYPE_8: "应用任意X晚",
    SCHEDULINGTYPE_9: "自定义",
    SCHEDULINGTYPE_0: "所有晚",
    EXAMPLE: "示例",
    STARTING_FROMM_NIGHT: "开始晚",
    ENDS_ON_NIGHT: "结束晚",
    USE_CYCLE: "使用周期",
    NUMBER_OF_REPETITION: "重复次数",
    NUMBER_OF_REPETITION_DETAIL: "使用周期（每X晚应用1次）",
    NIGHT_14_DESCRIPTION: "如果预订超过14晚，14晚后将根据选择的周期再次应用服务",
    CODE_NOT_EMPTY: "代码不能为空或重复",
    BEFORE_THE_LAST_NIGHT: "在最后一晚之前",
    LAST_NIGHT: "最后一晚",
    CONFIRM_UPDATE_PRICE_SERVICE_GREATER_THAN_TOTAL_PACKAGE: "分配价格大于总套餐价格，您确认更新吗？",
    EDIT_ATTRIBUTION: "编辑归属",
    MIN_ROOM_RATE: "最低房价",
    SETUP_FORMULA: "更新公式",
    SETUP_FORMULA_BY_DATE_RANGE: "按日期范围更新公式",
    DELETE_FORMULA: "删除公式",
    CAN_NOT_CREATE: "无法创建房间销售，因为它依赖于父房间销售",
    HAVE_BEEN_CONNECTED_TO_OTA: "房型/套餐已连接至OTA",
    CAN_NOT_INACTIVE_OR_DELETE: "无法更新",
    ROOM_RATE_IS_CHILDREN: "正在更新的产品是派生产品",
    TO_LESS: "小于",
    COMBO: "套餐",
    TITLE_DESCRIPTION_DYNAMIC_CHANGE: "按事件更改方法允许酒店配置按事件更改动态定价/限制，与库存相关，包括：",
    CHANGE_TYPE_1: "从PMS更新库存",
    CHANGE_TYPE_2: "从在线渠道推送/拉取预订",
    CHANGE_TYPE_3: "激活/停用房型",
    CHANGE_TYPE_4: "创建/修改动态定价公式",
    CHANGE_TYPE_5: "更改房价",
    CHANGE_TYPE_6: "关闭/打开房间",
    SCHEDULE_DYNAMIC_PRICING: "动态房间销售配置",
    HAVE_BEEN_CONNECTED_TO_DYNAMICPRICING: "无法删除，因为该产品设置了动态定价",
    SERVICE_INCLUDES: "服务包括",
    CHAIN_INFO: "基本信息 - 链",
    CHAIN_ROOM_TYPE: "房型 - 链",
    CHAIN_RATE_PLAN: "房价套餐 - 链",
    CHAIN_ROOM_TYPE_AMENITY: "房间设施 - 链",
    CHAIN_SERVICE: "服务 - 链",
    CODE_NOT_VALIDATE: "代码无效",
    PAYMENT_CODE: "支付代码",
    PAYMENT_TYPE: "交易类型",
    PAYMENT_STATUS: "交易状态",
    PAYMENT: "支付",
    REFUND: "退款",
    CANCELLATION_REFUND: "取消退款",
    CANCELLATION_FEE: "取消费用",
    WAITING_PAYMENT: "待支付",
    SUCCESS_PAYMENT: "支付成功",
    FAILED: "失败",
    CHAIN_NOT_EXIST: "链不存在",
    CHAIN_TRAVEL_AGENT: "公司和代理商信息 - 链",
    HOTEL_TRAVEL_AGENT: "公司和代理商信息",
    BE_MANAGEMENT: "ezBe",
    THE_SYSTEM_IS_LOADING: "系统正在加载，请稍等",
    OTA_HOTEL_NOT_FOUND: "未找到OTA酒店",
    ROOM_CLASS_MAPING: "连接房型",
    CONFIRM_SAVE: "您刚刚更改了连接信息，此操作可能会导致连接丢失、解绑和超售",
    UNDO: "撤销",
    CONFIRM_UNDO: "您刚才的更改将不会保存，您确定要撤销吗",
    DEFAULT_LANGUAGE: "使用的主要语言",
    RE_SYNC_CONNECT: "重新同步",
    ez_FOLIO: "ezFolio",
    ez_CLOUDHOTEL: "ezCloudHotel",
    ADVANCE_SEARCH: "高级搜索",
    PRICE_OR_OTA_IS_REQUIRED: "销售价格或销售渠道不能为空",
    UPDATE_BY_ROOM_TYPE: "按房型更新",
    UPDATE_BY_SALE_PACKAGE: "按房价套餐更新",
    UPDATE_BY_SALE_CHANNEL: "按OTA渠道更新",
    BULK_DELETE: "批量删除",
    CONFIRM_UPDATE_OVERWRITE: "更新确认将覆盖所有选择的销售渠道中的价格和人数",
    ONLY_UPDATE_PRICE: "仅覆盖价格",
    DAILY_MASTER_RATE: "派生每日价格",
    NUMBER_NIGHT: "晚",
    NUMBER_ROOM: "房间",
    ROOM_CAP: "0房间 | 1房间 | {count}房间",
    BOOKING_CAP: "0预订 | 1预订 | {count}预订",
    CHECKIN_STATUS_RESERVED: "已预订",
    CHECKIN_STATUS_CHECKIN: "已入住",
    CHECKIN_STATUS_CHECKOUT: "已退房",
    CHECKIN_STATUS_NO_SHOW: "未到",
    CHECKIN_STATUS_ARRIVAL: "到达",
    CHECKIN_STATUS_DUE_OUT: "待退房",
    CHECKIN_STATUS_CANCELLED: "已取消",
    NAME_OF_GUEST_STAYING: "入住客人",
    PRICE_EXTRA_DAILY: "每日附加费用",
    CHANNEL: "0渠道 | 1渠道 | {count}渠道",
    ASSIGN_RATE_TO_CATEGORY: "将价格计划分配到目录",
    _CATEGORY: {
        CODE: "类别代码",
        NAME: "类别名称",
        DESCRIPTION: "描述"
    },
    ASSIGN_HOTEL_TO_CATEGORY: "将类别分配给酒店",
    CHAIN_REGIS_INFO: "链条注册信息",
    CONFIRM_DELETE_RATE_CATEGORY: "确认删除价格类别",
    RATE_CATEGORY_ALREADY_EXIST: "价格类别已存在",
    RATE_PLAN_DOES_NOT_EXIST: "价格计划不存在",
    CANCEL_REASON: "取消原因",
    RATE_PMS: "PMS销售价格",
    ALL_PLAN: "所有价格计划",
    ALL_RATE_CATEGORY: "所有价格类别",
    TO_PAGE: "列表从1到{count}",
    ASSIGN_ROOM_TYPE: "房间分配",
    CONFIG_RATE_OTA: "OTA价格配置",
    CONFIG_RATE_PMS: "PMS价格配置",
    UPDATE_RATE_PMS: "更新价格",
    VIEW: "查看",
    CONFIRM_DELETE_SALE_PACKAGE_DATE_RANGE_PMS: "所选期间的价格将在其他房型和销售套餐中删除。<br>您确定要删除该价格吗？",
    WAITING_UPDATE: "数据已记录，正在处理",
    STATUS_ROOM_TYPE_ON_OTA: "OTA上的连接状态",
    BOOKING_LIST_GROUP: "团体预订",
    _GROUP_STATUS: {
        HOLD: "保留",
        TENTATIVE: "暂定",
        CONFIRMED: "已确认",
        CANCELED: "已取消",
        CHECKED_IN: "已入住",
        CHECKED_OUT: "已退房",
        CLOSE: "已关闭",
        NO_SHOW: "未到"
    },
    _BOOKING_GROUP: {
        BOOKING_GROUP_NAME: "团队预订名称",
        BOOKING_GROUP_CODE: "团队预订代码",
        GROUP_PROFILE_NAME: "团队档案名称",
        GROUP_PROFILE_CODE: "团队档案代码",
        BOOKING_GROUP_START_DATE: "开始日期",
        BOOKING_GROUP_END_DATE: "结束日期",
        BOOKING_GROUP_CREATE_DATE: "创建时间",
        STATUS: "团队状态"
    },
    ENTER_TEXT: "输入{text}",
    LIST_PROFILE_GROUP: "团队记录列表",
    PROFILE_GROUP: "团队档案",
    SEARCH_BY_PROFILE_NAME_AND_CODE: "按档案名称或档案代码、电子邮件、地址搜索",
    BOOKINGS_GROUP: "团队预订数量",
    PROFILE_NUMBER: "{count}条记录",
    _GROUP: {
        CONFIRM_DELETE: "确认删除团队记录",
        DETAIL: "团队档案详情",
        INFO: "档案信息",
        INFO_MANAGE: "管理信息",
        ASSIGN: "分配代表",
        GROUP_PROFILE_NAME: "档案名称",
        GROUP_PROFILE_NAME_OTHER: "其他名称",
        COMPANY_NAME: "公司/代理商名称",
        DESCRIPTION: "描述",
        CONTACT_NAME: "代表名称",
        PHONE_NUMBER: "电话号码",
        PHONE_NUMBER_OTHER: "其他电话号码",
        MANAGE_NAME: "经理的姓名",
        DETAIL_BOOKING: "团队预订详情",
        GROUP_INFO: "团队信息",
        LEADER: "负责人",
        PMS_CCODE: "PMS代码",
        CUS_OF_DAYS: "截止天数",
        CUT_OF_DATE: "截止日期",
        PAYMENT_INFO: "付款信息",
        TOTAL: "总金额",
        UPDATE_PROFILE: "更新团队档案",
        PAYMENT_METHOD: "付款方式",
        PAYMENT_METHOD_BOOKING_RETAIL: "个人付款方式",
        BOOKING_GROUP_INFO: "团队预订信息",
        LEADER_NOT_PAY: "负责人未付款",
        LEADER_PAY_ONE_PART: "负责人部分付款",
        LEADER_PAYS_ALL: "负责人全额付款",
        CHOOSE_PROFILE: "选择团队档案",
        TITLE: "标题"
    },
    ROOM_OF_LEADER: "领导房间",
    NUMBER_OF_BOOKING: "预订数量",
    SUB_BOOKING_CODE: "子团代码",
    UPDATE_INFO_BOOKING_GROUP: "更新团体预订文件信息",
    ALLOW_OVERWRITING_INFOMATION_DOWN: "允许信息覆盖",
    FILTER: "过滤器",
    GROUP_PROFILE: "团队档案",
    BOOKING_GROUP_PROFILE: "预订团队",
    ASSIGN_HOTEL: "酒店分配",
    ASSIGN_ROOM_TO_CATEGORY: "将房间分配到类别",
    UPDATE_ROOM_RATE_PMS: "配置PMS价格",
    UPDATE_ROOM_RATE_OTA: "配置OTA价格",
    BOOKING_UNMAP: "解除预订映射",
    CONFIRM_DELETE_ROOM_CATEGORY: "确认删除房间类别",
    CHAIN_ROOM_CATEGORY_ALREADY_EXIST: "链条房间类别已存在",
    ROOM_CATEGORY_ALREADY_EXIST: "房间类别已存在",
    ASSIGN_OTA: "频道分配",
    NOTE_ASIGN_OTA: "备注：如果点击保存，销售渠道将自动分配给所选房间类别，并同步到订阅该频道的酒店",
    ACTION_TIME: "更新时间",
    PROCESS_TIME: "处理时间",
    IGNORE: "忽略",
    RESEND: "重新更新",
    LIST_ACTION_PROCESS: "未完成的操作",
    STATUS_PROCESSING: "处理中",
    STATUS_FAILED: "失败",
    STATUS_DONE: "完成",
    UPDATE_RATE: "更新价格",
    UPDATE_RATE_SPECIAL: "更新日常价格",
    UPDATE_EXTRA_RATE: "更新附加费用",
    UPDATE_EXTRA_SPECIAL_RATE: "更新每日附加费用",
    UPDATE_AVAIL: "更新可用性",
    UPDATE_RESTRICTION: "更新限制",
    PROCESS_CAP: "0个进程 | 1个进程 | {count}个进程",
    CONFIRM_IGNORE: "错误操作将不再执行更新。您确定要选择跳过吗？",
    HOTEL_BOOKING_UNMAP_REPOST: "重新发布预订",
    UPDATE_RESTRICTION_MINSTAY: "更新最少入住天数",
    UPDATE_RESTRICTION_MAXSTAY: "更新最大入住天数",
    UPDATE_RESTRICTION_MINSTAYARRIVAL: "更新最少到达天数",
    UPDATE_RESTRICTION_MAXSTAYARRIVAL: "更新最大到达天数",
    UPDATE_RESTRICTION_MINBOOKINGWINDOW: "更新最短预订窗口",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOW: "更新最长预订窗口",
    UPDATE_RESTRICTION_EXACTSTAY: "更新确切入住天数",
    UPDATE_RESTRICTION_EXACTSTAYARRIVAL: "更新确切到达天数",
    UPDATE_RESTRICTION_CLOSEDONARRIVAL: "更新不允许到达",
    UPDATE_RESTRICTION_CLOSEDONDEPARTURE: "更新不允许退房",
    UPDATE_RESTRICTION_CLOSED: "更新停止销售",
    DELETE_PRICE_SPECIAL: "删除日常价格",
    DELETE_EXTRA_RATE: "删除附加费用",
    DELETE_EXTRA_SPECIAL_RATE: "删除每日附加费用",
    HOTEL_DASHBOARD_IGNORE_TASK: "忽略",
    HOTEL_DASHBOARD_REUPDATE_TASK: "重新更新",
    CHAIN_ROOM_UPDATE_QUANTITY: "更新房间数量",
    ROOM_UPDATE_QUANTITY: "更新房间数量",
    CHAIN_ROOM_CATEGORY: "房间类别 - 链条",
    HOTEL_ROOM_CATEGORY: "房间类别",
    HOTEL_RATE_CATEGORY: "房间类别",
    CHAIN_RATE_CATEGORY: "价格类别 - 链条",
    ERROR_CAUSE: "错误原因",
    INVENTORY_NOT_SYNC: "空房未同步",
    UNKNOWN_ERROR: "未知错误",
    BY_RATE: "按固定价格",
    BY_FORMULA: "按公式",
    CONFIG_TYPE: "配置类型",
    FOMULA_FROM_TO: "计算从星期一到星期天的价格公式",
    CONFIRM_DEACTIVE_DYNAMIC_RESTRICTION: "确认停用灵活限制",
    EDIT_DYNAMIC_RESTRICTION: "灵活限制模板见解",
    ADD_NEW_DYNAMIC_RESTRICTION: "添加新的灵活限制模板",
    DYNAMIC_RESTRICTION: "动态限制",
    CONFIRM_DELETE_DYNAMIC_RESTRICTION: "确认删除灵活限制模式",
    DYNAMIC_RESTRICTION_NAME: "灵活限制模板名称",
    DYNAMIC_RESTRICTION_DESCRIPTION: "灵活限制模式描述",
    RESTRICTION_CALCULATION_FORMULA: "配置信息",
    NO_CHANGE: "无变化",
    ADULT_CAP: "0成人 | 1成人 | {count}成人",
    CHILD_CAP: "0儿童 | 1儿童 | {count}儿童",
    BABY_CAP: "0婴儿 | 1婴儿 | {count}婴儿",
    USE_MODEL: "设为模型",
    ADD_RANGE: "添加范围",
    MODEL_DESCRIPTION_RESTRICTION: "如果选择，则价格/价格公式/容量范围/限制将复制到下方的房型和销售套餐。",
    MODEL_DESCRIPTION_PRICE: "如果选择，则价格/价格公式/容量范围/限制将复制到下方的房型和销售套餐。",
    NOTE_ROOM_RATE: "B: 对应房型的房间价格。房间价格会显示并在房间销售屏幕上更新。当创建新房间价格时，会从房型中的默认房间价格中获取。",
    DYNAMIC_SALE: "动态房间销售",
    NOTE_MODEL_PRICE: "用户可以编辑从模板复制的房型",
    ACCOUNT_UPDATE: "更新账户",
    ITEMS_PER_PAGE: "每页行数",
    UPDATE_RATE_SPECIAL_FROM_CHAIN: "从链条更新价格",
    EQUIVALENT_TO_ROOM_NIGHT: "等同于房晚",
    CREATED_BY_ACCOUNT: "由账户创建",
    IS_LEGACY_ROOM_CLASS: "无法删除，因为房型和价格计划是派生的",
    ASSIGN_RATE_CATEGORY: "分配价格类别",
    ASSIGN_ROOM_CATEGORY: "分配房间类别",
    CUSTOMER_PHONE: "客户的电话号码",
    CUSTOMER_MAIL: "客户订单的电子邮件",
    DU_DESCRIPTION_OF_ROOM_TYPE: "房型的日间使用预订（到达日期=离开日期的预订）",
    DU_DESCRIPTION_OF_HOTEL: "酒店的日间使用预订（到达日期=离开日期的预订）",
    OVERVIEW: "概述",
    INDEX_P: "入住率 (P)",
    INDEX_P_ROOM: "按房型的容量",
    INDEX_P_HOTEL: "按酒店的入住率",
    INDEX_A: "已售房间数 (包括日间使用) (A)",
    INDEX_B: "可售房间数 (B)",
    INDEX_DU: "已售日间使用房间数 (DU)",
    INDEX_INV: "可用房间",
    BY_ROOM: "按房型",
    BY_HOTEL: "按酒店",
    DYNAMIC_NAME_HAS_EXIST: "动态名称已存在",
    ROOM_SALE_WITH_ROOM_TYPE: "查看房型",
    ROOM_SALE_WITH_OTA: "按渠道查看",
    ROOM_FUND: "配额",
    NODATA_2: "请输入超过2个字符",
    CHOOSE_MARKET_SEGMENT: "选择市场细分",
    MARKET_SEGMENT: "市场细分",
    TRAVEL_AGENT_SPEC: "特定代理商",
    SEGMENT_SPEC: "特定市场细分",
    SHOW_CARD_PAYMENT_INFO: "显示卡信息",
    ENTER_TO_SEARCH_MORE: "输入以查看更多",
    EMAIL_ACCESSTOKEN: "接收卡信息访问代码的电子邮件",
    TEXT_NOTIFY_EXPIRED_GROUP_OTA: "{channel}功能已于{date}过期",
    TEXT_NOTIFY_WILL_EXPIRE_GROUP_OTA: "{channel}功能将于{date}过期",
    PLEASE_RENEW: "请通过电子邮件<u>hotro@ezcloud.vn</u>或热线<u>1900 9013</u>联系我们以获取支持。",
    NOTIFY_OFF_MODULE: "按房型销售功能将在不久的将来停止工作。请将您的所有反馈发送至邮箱<b>hotro@ezcloud.vn</b>",
    NEW_MESSAGE: "新消息",
    PAXONE: "1人价格",
    PAXTOW: "2人价格",
    PAXEXTRA: "每增加一个人的价格",
    MAP_PRODUCT: "分配产品",
    UPDATE_RESTRICTION_BY_RATE_PLAN: "更新限制",
    CREATE_RESTRICTION: "创建限制",
    DELETE_ROOM_RATE: "删除房价",
    UPDATE_SPECIAL_RATE: "更新日常价格",
    HERE: "这里",
    ACCESS_TOKEN_EMAIL_IS_NOT_EMPTY: "请输入接收卡信息的电子邮件",
    ADD_PROGRAM: "添加程序",
    TYPE_APPLY_PROMOTION: "促销系统",
    PROMOTION_CHARCE_COUPON: "促销，折扣代码",
    PROMOTION_CHARGE: "促销适用",
    COUPON_APPLY: "折扣代码适用",
    EZ_PROMOTION_NOT_SUPPORTED_PROMOTION_TYPE: "ezPromotion系统不支持此类促销",
    ERROR_EZ_PROMOTION: "无法连接到ezPromoion系统",
    CANCEL_PROMOTION_ERROR: "促销取消失败",
    CONFIRM_PROMOTION_ERROR: "促销确认失败",
    RELOAD: "刷新",
    WARNING: "警告",
    TXT_WARNING_OVER: "为了确保系统性能，每次操作更新行数不应超过50行。谢谢！",
    CONFIRM_DELETE_DATA_ENTERED: "您刚刚对主产品进行了更改。是否删除刚刚输入的价格数据？",
    ROOM_STATUS_1: "已预订",
    ROOM_STATUS_2: "已入住",
    ROOM_STATUS_3: "已退房",
    ROOM_STATUS_4: "未入住",
    ROOM_STATUS_5: "已取消",
    BOOKING_HISTORY: "预订历史",
    BOOKING_STATUS_OTA: "OTA预订状态",
    BOOKING_OTA_STATUS_0: "新预订",
    BOOKING_OTA_STATUS_1: "修改后的预订",
    BOOKING_OTA_STATUS_2: "取消预订",
    BOOKING_OTA_STATUS_3: "转发预订",
    COPY_RATE: "复制价格计划",
    SALE_PACKAGE_CODE_NEW: "新价格计划代码",
    SELLING_PACKAGE_NEW: "新价格计划名称",
    DUPLICATE: "重复",
    SALE_PACKAGE_CODE_OLD: "旧价格计划代码",
    FAST_UPDATE: "快速更新",
    AUTO_CANCEL_PAYMENT_FAIL: "允许在付款失败后自动取消预订",
    EZPAYREF: "参考代码",
    TOOLTIP_AUTO_CANCEL_PAYMENT_FAIL: "启用此功能后，如果预订处于付款失败状态并超过配置的时间，ezCrs将自动取消这些预订。首次设置的默认时间为30分钟。如果留空，则适用值为0分钟。<br>注意：取消时间可能因连接而延迟几分钟。",
    TOOLTIP_AUTO_CANCEL: "对于需要特定日期预付款的预订，在客户以现金或银行转账等无法记录的ezCrs表单方式付款/存款后，酒店必须确认该预订。如果启用此功能，ezCrs将自动取消当天未确认的预订。自动取消的预订日期将在支付政策中设置，并根据每个价格政策应用。",
    CONFIG_BY: "由设置",
    LIST_FORMULAR: "公式列表",
    ROOM_TYPE_BASE: "基础房型",
    SALE_PACKAGE_BASE: "基础价格政策",
    SALE_CHANNEL_BASE: "基础销售渠道",
    ROOM_TYPE_DERIVED: "派生房型",
    SALE_PACKAGE_DERIVED: "派生价格计划",
    SALE_CHANNEL_DERIVED: "派生销售渠道",
    HOTEL_LOG_derivationType: "配方类型",
    HOTEL_LOG_formulaType: "类型",
    HOTEL_LOG_master: "主",
    HOTEL_LOG_children: "子",
    HOTEL_LOG_formula: "公式",
    HOTEL_ROOM_TYPE_SPECIAL: "更新房间价格",
    UPDATE_ROOM_TYPE: "更新房型",
    TOOLTIP_BASE_ROOM_TYPE: "仅与房型 {value} 的产品共享相同的价格计划和销售渠道的派生类型内的房型产品，将根据公式进行派生。",
    TOOLTIP_BASE_RATE_PLAN: "仅与价格计划 {value} 的产品共享相同的房型和销售渠道的派生价格计划内的产品，将根据公式进行派生。",
    TOOLTIP_BASE_OTA: "仅与销售渠道 {value} 的产品共享相同的价格计划和房型的派生销售渠道内的产品，将根据公式进行派生。",
    VALUE_AND_PERSON_IS_REQUIRED: "价格和客人数不能为空",
    PLS_CHOOSE_ONE_SELECT_BOX: "请至少选择一个'删除'框以进行更新",
    NOTE_DERIVED: "如果新派生公式与派生产品或基础产品匹配，将覆盖之前的公式。",
    ROOM_QUANTITY_PARENT_NOT_SAME: "父级和子级房型的数量必须相等才能创建",
    IS_REDIRECTING: "正在重定向",
    MAP: "地图",
    SYNC_FROM_PRICELABS: "从Pricelabs同步",
    HOTEL_EXTRA_SPECIAL_RATE_DELETE: "删除每日额外收费",
    HOTEL_EXTRA_SPECIAL_RATE_UPDATE: "更新每日额外收费",
    SYNC_DATA_TO_OTA: "将数据同步到OTA",
    MODULE_EZ_PAYMENT_NOT_ACTIVE: "ezPayment模块未激活",
    NOT_DELETE_ROOM_TYPE_CODE_HAS_SYNCED_TO_OTA: "无法删除与OTA连接的房型",
    ENABLE_SYNC_NOT_UPDATED: "该房型当前已连接到OTA。请按照以下步骤操作，才能更改房型中的客人数量，因为更改可能会影响连接。<br><br>\
        <span class='font-weight-bold'>步骤1：</span>进入同步管理 => 选择ezCms vela+ => 选择OTA映射选项卡并断开您要更改的房型与所有连接的OTA渠道。<br>\
        <span class='font-weight-bold'>步骤2：</span>选择渠道选项卡，断开您要更改的房型。<br>\
        <span class='font-weight-bold'>步骤3：</span>更改客人数量并重新连接OTA渠道。<br><br>\
        <span class='font-weight-bold'>注意：</span>请按照正确的顺序执行步骤，以避免连接错误，可能会导致收入损失。<br>\
        详细信息请查看 <a href='https://help.ezcms.vn/tich-hop-he-thong-ezcms-vela/' target='_blank'><u>这里</u></a>",
    ENABLE_SYNC_NOT_CREATED: "该房型代码已存在于酒店级别，无法更改，因为它与OTA连接。请更改房型代码或调整此房型在链条或酒店中的客人数量。",
    UNDERSELL_LIMIT_TITLE: "设置渠道的可用房间阈值以控制房间销售。当该渠道上的可用房间数达到或低于此阈值时，将触发停止销售操作。",
    SELL_LIMIT_TITLE: "为渠道组设置最大房间限制，以控制房间销售并优化收入。",
    ROOM_FOR_SALE: "可售房间",
    NO_CHANNEL_GROUP: "请选择要更新的渠道组",
    DATA_BLANK: "输入数据不能为空",
    ROOM_QUANTITY_PARENT_NOT_SAME: "父级和子级房型的数量必须相等才能创建",
    VALUE_MUST_BE_LESS_THAN_24H: "该值必须小于24小时",
    N_O: "序号",
    MASTER_ROOM_TYPE: "主房型",
    MASTER_RATE_PLAN: "主价格计划",
    MASTER_CHANNEL: "主渠道",
    DERIVED_ROOM_TYPE: "派生房型",
    DERIVED_RATE_PLAN: "派生价格计划",
    DERIVED_CHANNEL: "派生渠道",
    MASTER_PRODUCT: "主产品",
    FORMULAR_LIST: "公式列表",
    DERIVED_PRODUCT: "派生产品",
    PRICE_FORMULA: "价格公式",
    SELECT_TYPE: "选择类型",

    SHOW_MORE_FOMULA: "显示更多公式",
    SELECT_TYPE_RESTRICTION: "选择限制类型",
    SETUP_FORMULAR_LIST: "设置公式列表",
    APPLY_DATE: "适用日期",
    LIST_FROM: "起始于",
    TO: "至",
    IN: "在",
    NO_TYPE_SELECTED: "请选择房价或其他限制类型以创建公式",
    ROOM_TYPE_NOT_MATCH: "无法设置公式，因为基础产品和派生产品之间的价格计划或渠道不匹配。请仔细检查或创建相应的产品。",
    SALE_PACKAGE_NOT_MATCH: "无法设置公式，因为基础产品和派生产品之间的房型或渠道不匹配。请仔细检查或创建相应的产品。",
    SALE_CHANNEL_NOT_MATCH: "无法设置公式，因为基础产品和派生产品之间的价格计划或房型不匹配。请仔细检查或创建相应的产品。",
    CUSTOM_NOT_MATCH: "由于主产品和子产品在房型、价格计划或渠道方面不兼容，因此无法建立公式。",
    CHANGE: "更改",
    CURRENT_FORMULA: "当前公式",
    NEW_FORMULA: "新建公式",
    MODIFIED_FORMULA: "已修改公式",
    DELETED_FORMULA: "已删除公式",
    DERIVED: "派生",
    LIST_FORMULAR_UPDATE: "已更新公式",
    BEFORE: "之前",
    AFTER: "之后",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "未找到房价派生数据",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "按小时更新最小预订窗口",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "按小时更新最大预订窗口",
    NUMBER_OF_DAYS: "天数",
    NUMBER_OF_HOURS: "小时数",
    REMOVE_DAYLY_RATE: "移除每日房价",
    ALLOW_CHECKIN: "允许入住",
    ALLOW_CHECKOUT: "允许退房",
    QUICK_UPDATE: "更新类型",
    BASE_PRICE_REQUIRED: "请先更新每周房价",
    CALENDAR_ROOM: "日历视图",
    SHOW_MORE_FOMULA: "显示更多公式",
    SELECT_TYPE_RESTRICTION: "选择限制类型",
    SETUP_FORMULAR_LIST: "设置公式列表",
    APPLY_DATE: "应用日期",
    LIST_FROM: "列出自",
    TO: "到",
    IN: "在",
    NO_TYPE_SELECTED: "请选择价格计划或任何类型的限制以创建公式",
    ROOM_TYPE_NOT_MATCH: "无法设置公式，因为基础产品和派生产品之间的价格计划或渠道不匹配。请仔细检查或创建相应的产品。",
    SALE_PACKAGE_NOT_MATCH: "无法设置公式，因为基础产品和派生产品之间的房型或渠道不匹配。请仔细检查或创建相应的产品。",
    SALE_CHANNEL_NOT_MATCH: "无法设置公式，因为基础产品和派生产品之间的价格计划或房型不匹配。请仔细检查或创建相应的产品。",
    CUSTOM_NOT_MATCH: "由于主产品和子产品之间的房型、价格计划或渠道不兼容，未建立公式。",
    CHANGE: "更改",
    CURRENT_FORMULA: "当前公式",
    NEW_FORMULA: "创建的公式",
    MODIFIED_FORMULA: "修改后的公式",
    DELETED_FORMULA: "已删除的公式",
    DERIVED: "派生",
    LIST_FORMULAR_UPDATE: "已更新的公式",
    BEFORE: "之前",
    AFTER: "之后",
    ROOM_RATE_DERIVATIONS_NOT_FOUND: "未找到房价派生",
    UPDATE_RESTRICTION_MINBOOKINGWINDOWBYHOUR: "按小时更新最短预定窗口",
    UPDATE_RESTRICTION_MAXBOOKINGWINDOWBYHOUR: "按小时更新最长预定窗口",
    NUMBER_OF_DAYS: "天数",
    NUMBER_OF_HOURS: "小时数",
    REMOVE_DAYLY_RATE: "移除每日价格",
    ALLOW_CHECKIN: "允许入住",
    ALLOW_CHECKOUT: "允许退房",
    QUICK_UPDATE: "更新类型",
    BASE_PRICE_REQUIRED: "请先更新每周价格",
    CALENDAR_ROOM: "日历视图",
    WARNING_EMAIL: "电子邮件",
    SAFE_PRICE_RANGE: {
        PROTECTION_RATE: "保护率",
        PROTECTION_RATE_TOOLTIP: "保护率是指在房价输入低于设定的最低价格或高于最高价格时，将不允许保存的价格范围。",
        MINIMUM_RATE: "最低价格",
        MAXIMUM_RATE: "最高价格",
        MINIMUM_RATE_INVALID: "最低价格不能高于最高价格。",
        MAXIMUM_RATE_INVALID: "最高价格不能低于最低价格。",
        PROTECTION_RATE_INPUT_INVALID: "输入的值不能低于 {priceMin} 或高于 {priceMax}。",
        MINIMUM_RATE_INPUT_INVALID: "输入的值不能低于 {priceMin}。",
        MAXIMUM_RATE_INPUT_INVALID: "输入的值不能高于 {priceMax}。",
    },
    PRICE_OUT_OF_BOUND: "输入的价格超过了保护率。",
    PRICE_UPDATE_OUT_OF_BOUND: "当前的销售价格超过了保护率。",
    INCLUDED_TAX: "含税",
    ACTIVATE: "激活",
    NO_RANK: "无等级",
    ONE_STAR: "一星",
    TWO_STAR: "二星",
    THREE_STAR: "三星",
    FOUR_STAR: "四星",
    FIVE_STAR: "五星",
    EXAMPLE_INFO: `<p><i><u><span>示例:</span></u></i></p> 
    <p>酒店使用的货币: <span>VND</span></p> 
    <p>豪华房的申报价格: <span>900,000</span></p> 
    <p>汇率: <span>0.00005</span></p> 
    <p>价格差异: <span>0.5</span></p> 
    <p>同步后，豪华房在OTA渠道的销售价格为: <span>(900,000 x 0.5) + 0.5 = 50 $</span></p>`,
    FREE_SALE_ALLOTMENT: "截止日期前的自由销售配额",
    ACTIVITY_LOG: "0 条日志 | 1 条日志 | {count} 条日志",
    TIPS: "小贴士",
    _CONFIGURATION: {
        MENU: "菜单",
        WIDGET: "小部件",
        THEME: "主题",
        SCRIPT: "脚本",

        MENU_HEADER: "菜单头部",
        MENU_FOOTER: "菜单底部",

        LOGO: "Logo",
        HEADER: "头部",
        BE_CONTENT: "BE 内容",
        FOOTER: "底部",
        FOOTER_BOTTOM: "底部下方",
        FOOTER_RIGHT: "底部右侧",
        WIDGET_FOOTER_RIGHT: "小部件 底部右侧",
        WIDGET_FOOTER_BOTTOM: "小部件 底部下方",

        WIDGET_SOCIAL_MEDIA_ICON: "小部件: 社交媒体图标",
        WIDGET_HTML_TEXT: "小部件: HTML 文本",
        SCRIPT_WILL_ADD_BODY: "脚本将添加到 <body> 部分",
        SCRIPT_WILL_ADD_HEAD: "脚本将添加到 <head> 部分",
        TEMPLATE: "模板",
        BODY: "主体",
        BE_SUPPORT: `<p class="fs-14"><b>方法 1：通过预先创建的表单进行集成</b></p>
        <p>此功能允许您将预订引擎与网站集成。具体来说，它可以在您的网站上显示预订引擎的预订表单。</p>
        <img src="/script-BE.png">
        <br>
        <p><b>步骤 1：</b>复制下面的 HTML 代码并将其放置在您希望在网站上显示预订表单的位置。</p>
        <div>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </div>
        <div class="mt-3">
            <p><b>步骤 2：</b>复制下面的脚本并将其放置在网站的页脚中（在关闭 body 标签之前）。</p>
            <p>1. 如果网站上没有 jQuery：</p>
            <i> &emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-jquery-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt;<br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62');<br>
            &emsp;&lt;/script&gt;<br></i>
        </div>
        <div class="mt-3">
            <p>2. 如果网站上已有 jQuery（当脚本冲突时）：</p>
            <i>&emsp;&lt;script src="https://apps.oneinventory.com/plugins/ezbe-chain-5s.js"&gt;&lt;/script&gt; <br>
            &emsp;&lt;script&gt; <br>
            &emsp;&emsp;create_booking_form('XXXXXX', '.booking-form', 'vi', 'VND', 'horizontal', '#ffffff', '#fc5b62'); <br>
            &emsp;&lt;/script&gt; <br></i>
        </div>
        <br>
        <p><b>步骤 3：</b>根据您的网站需求调整 <b>create_booking_form</b> 函数中的参数，然后保存。</p>
        <p class="mb-1"><b>其中：</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>XXXXXX</i> : 您的酒店代码（必填）。</p>
            <p class="mb-1"><i>.booking-form</i> : 步骤 1 中声明的 HTML 元素的 ID (#) 或类名 (.)（必填）。</p>
            <p class="mb-1"><i>vi</i> : 显示语言代码（可选）。支持 2 种语言代码：</p>
                <p class="mb-1 ml-5"><i>vi</i> : 越南语</p>
                <p class="mb-1 ml-5"><i>en</i> : 英语</p>
            <p class="mb-1"><i>VND</i> : 预订引擎显示的货币单位代码，符合国际货币单位标准（可选）。</p>
            <p class="mb-1"><i>horizontal</i>: 表单显示类型（可自定义）。支持 2 种类型：</p>
            <p class="mb-1 ml-5"><i>horizontal</i>: 水平显示</p>
            <p class="mb-1 ml-5"><i>vertical</i>: 垂直显示</p>  
            <p class="mb-1"><i>#ffffff</i> : 搜索按钮的文字颜色代码（可选）。</p>
            <p class="mb-1"><i>#fc5b62</i> : 搜索按钮的背景颜色代码（可选）。</p>
        </div>
        <hr>
        <p class="fs-14"><b>方法 2：通过访问链接进行集成</b></p>
        <p>将链接赋值给按钮或文本链接。使用以下示例链接：</p>
        <div>
            <i>https://booking.ezcms.vn/hotel/BeDetailHotel?hotel_code=XXXXXX&check_in=2020-11-30&check_out=2020-12-01&num_of_rooms=1&num_of_adults=2&num_of_children=0&promo_code=&rate_code=&room_code=&lang=vi&amp;currency=VND</i>
        </div>
        <br>
        <p class="mb-1"><b>其中：</b></p>
        <div class="ml-3">
            <p class="mb-1"><i>hotel_code</i>: 酒店代码（必填）</p>
            <p class="mb-1"><i>check_in</i>: 入住日期，格式为 YYYY-MM-DD（可选）</p>
            <p class="mb-1"><i>check_out</i>: 离店日期，格式为 YYYY-MM-DD（可选）</p>
            <p class="mb-1"><i>num_of_rooms</i>: 房间数量（可选）</p>
            <p class="mb-1"><i>num_of_adults</i>: 成人数量（可选）</p>
            <p class="mb-1"><i>num_of_children</i>: 儿童数量（可选）</p>
            <p class="mb-1"><i>room_code</i>: 房间类型代码（可选）</p>
            <p class="mb-1"><i>rate_code</i>: 价格政策代码（可选）</p>
            <p class="mb-1"><i>promo_code</i>: 促销代码（可选）</p>
            <p class="mb-1"><i>lang</i> : 显示语言代码（可选）</p>
            <p class="mb-1"><i>currency</i> : 显示货币单位代码（可选）</p>
        </div>
        <hr>
        <p class="fs-14"><b>方法 3：直接嵌入到酒店官网</b></p>
        <p>此功能允许您将预订引擎直接嵌入到酒店官网中，仅用于显示酒店在 Booking Engine 上的房间列表。</p>
        <p class="mb-3">
            <b>步骤 1：</b>复制以下 HTML 示例代码，并粘贴到您想要显示预订表单的位置：<br/>
            <i>&lt;div class="booking-form"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            <b>步骤 2：</b>复制以下脚本代码，并粘贴到网页底部（&lt;/body&gt; 之前）：<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingForm({<br>
                &emsp;&emsp;&emsp; hotel: [{ hotelName: 'Hotel A', hotelCode: 'KSA' }],<br> 
                &emsp;&emsp;&emsp; target: '.booking-form',<br>
                &emsp;&emsp;&emsp; path: '/room-list',<br>
                &emsp;&emsp;&emsp; lang: 'zh',<br>
                &emsp;&emsp;&emsp; background: '#ffffff',<br>
                &emsp;&emsp;&emsp; buttonBackground: '#ff0000',<br>
                &emsp;&emsp;&emsp; buttonTextColor: 'white',<br>
                &emsp;&emsp;&emsp; textColor: '#333333'<br>
                &emsp;&emsp; });<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>步骤 3：</b>根据酒店官网页面风格，自行调整 <b>window.initBookingForm</b> 参数配置后保存。
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>参数说明：</b></p>
            <p class="mb-1">
                - <i>hotel</i>：酒店信息。支持多个酒店，每个酒店是一个对象。（必填）<br/>
                <span style="padding-left: 12px;"><i>hotelName</i>：酒店名称</span><br/>
                <span style="padding-left: 12px;"><i>hotelCode</i>：酒店代码</span><br/>
            </p>
            <p class="mb-1">
                - <i>target</i>：HTML 中的 ID (#) 或类名 (.)，对应步骤 1 插入的 booking-form（必填）
            </p>
            <p class="mb-1">
                - <i>path</i>：跳转到房型列表的路径。如果未设置，将跳转到 <code>https://booking.ezcms.vn</code>（可选）
            </p>
            <p class="mb-1">
                - <i>lang</i>：显示语言。如果未设置，默认显示越南语。（可选）<br/>
                <span style="padding-left: 12px;"><b>支持 7 种语言：</b></span><br/>
                <span style="padding-left: 12px;"><i>vi</i>：越南语</span><br/>
                <span style="padding-left: 12px;"><i>en</i>：英语</span><br/>
                <span style="padding-left: 12px;"><i>ja</i>：日语</span><br/>
                <span style="padding-left: 12px;"><i>ko</i>：韩语</span><br/>
                <span style="padding-left: 12px;"><i>lo</i>：老挝语</span><br/>
                <span style="padding-left: 12px;"><i>km</i>：高棉语</span><br/>
                <span style="padding-left: 12px;"><i>zh</i>：中文</span><br/>
                <span style="padding-left: 12px;"><b>备注：</b>若 Booking Engine 不支持指定语言，将自动显示为英文。</span>
            </p>   
            <p class="mb-1">
                - <i>background</i>：表单背景颜色，默认值：#eee（可选）
            </p>
            <p class="mb-1">
                - <i>buttonTextColor</i>：预订按钮文字颜色，默认值：#fff（可选）
            </p>
            <p class="mb-1">
                - <i>buttonBackground</i>：预订按钮背景颜色，默认值：红色（可选）
            </p>
            <p class="mb-1">
                - <i>textColor</i>：表单文字颜色，使用浏览器默认设置（可选）
            </p>  
        </div>
        <p class="mt-3 mb-0">
            <b>步骤 4：</b>在您在步骤 3 中设定的 path 页面上：
        </p>
        <p class="mb-0">
            插入以下 HTML 代码以显示房间列表：<br/>
            <i>&lt;div id="room-list"&gt;&lt;/div&gt;</i>
        </p>
        <p class="mb-3">
            将以下脚本粘贴至网页底部（&lt;/body&gt; 前）：<br/>
            <i> &emsp;&lt;script src="https://app.oneinventory.com/booking-engine/plugins/ezbe-embed.js"&gt;&lt;/script&gt; <br>
                &emsp;&lt;script&gt;<br>
                &emsp;&emsp;window.initBookingEngine({<br>
                &emsp;&emsp;&emsp; target: '#room-list',<br>
                &emsp;&emsp;&emsp; scrollToTop: true,<br>
                &emsp;&emsp;&emsp; marginTop: 0<br>
                &emsp;&emsp;});<br>
                &emsp;&lt;/script&gt;<br>
            </i>
        </p>
        <p class="mb-0">
            <b>步骤 5：</b>根据页面需求修改 <b>window.initBookingEngine</b> 参数配置后保存。
        </p>
        <div class="ml-3">
            <p class="mb-0"><b>参数说明：</b></p>
            <p class="mb-1">
                - <i>target</i>：HTML 中的 ID (#) 或 class (.)，对应步骤 4 中插入的房型列表（必填）
            </p>
            <p class="mb-1">
                - <i>scrollToTop</i>：启用页面滚动至顶部的按钮，当滚动超过 500px 时显示，点击后返回顶部。默认值为 false。（可选）
            </p>
            <p class="mb-1">
                - <i>marginTop</i>：在顶部创建间距。目的是防止内容被上方的固定元素遮挡，例如网站的固定页眉（可选）。
            </p>
        </div>
        <p style="margin-top: 10px;"><b>点击查看 Demo：</b><a href="https://app.oneinventory.com/booking-engine" target="_blank">点此访问</a></p>`,
    },
    CONFIRM_TRANET_CONNECT: `{roomConfirm} 超过了最大容纳人数18人。如果点击地图，可能会发生<span class="font-weight-bold">映射失败</span>的错误。请再次确认。`,
    _PROMOTION: {
        MEALS: {
            BREAKFAST: "早餐",
            LUNCH: "午餐",
            DINNER: "晚餐",
        },
        PROMOTION_TYPE_LIST: {
            EVERY_NIGHT: "每晚",
            TOTAL_BOOKING: "总预订金额",
            ORDER_BEFORE: "在入住前x天预订",
            ORDER_WITHIN: "在入住前x天内预订",
            FREE_QUANTITY: "订购x件，赠送y件",
            FREE_ON_TOTAL_VALUE: "订购x件，按总金额赠送y件",
        },
        DISCOUNT_LIST: {
            DISCOUNT: "折扣",
            SURCHARGE: "附加费",
        },
        TARGET_APPLY_LIST: {
            BY_AGENT_LEVEL: "按代理等级",
            BY_AGENT: "按代理",
        },
        LEVEL_TARGET_APPLY: {
            LEVEL_1: "等级1",
            LEVEL_2: "等级2",
            LEVEL_3: "等级3",
            LEVEL_4: "等级4",
            LEVEL_5: "等级5",
        }
    },
    UTM_CODE: "UTM代码",
    ZOOM: "变焦",
    UPDATE_RESTRICTION_SALEINVENTORY: "更新可售房间",
    UPDATE_RESTRICTION_SELLLIMIT: "更新销售限制",
    ROOM_TYPE_ON_SABRE_DUPLICATE: "销售渠道中的房型不能重复",
    ROOM_PLAN_ON_SABRE_DUPLICATE: "销售渠道中的价格计划不能重复",
    UPDATE_FAILED: "更新失败",
    DELETE_FAILED: "删除失败",
    CREATE_FAILED: "创建失败",
    UPLOAD_FAILED: "上传失败",
    USER_NOT_RIGHT: "没有权限",
    USER_NOT_EXIST: "账户不存在",
    EMAI_IS_EXIST: "邮箱已存在",
    ACTIVE_SUCCESS: "激活成功",
    DEACTIVE_SUCCESS: "取消关联成功",
    TODAY: "今天",
    YESTERDAY: "昨天",
    TOMORROW: "明天",
    LOGIN_FAILED: "登录失败",
    ONEPAY_INLAND: "OnePay 国内",
    ONEPAY_OVERSEA: "OnePay 海外",
    VN_PAY: "VN Pay",
    SUN: "星期日",
    MON: "星期一",
    TUE: "星期二",
    WED: "星期三",
    THU: "星期四",
    FRI: "星期五",
    SAT: "星期六",
    UNDER_MAX_GUEST: "客人数超出了定价政策所允许的最大限制",
    SAVE_RESULTS_WHEN_MAKING_CHANGES: "变更后保存结果",
    $vuetify: {
        badge: '徽章',
        close: '关闭',
        dataIterator: {
            noResultsText: '没有符合条件的结果',
            loadingText: '加载中……'
        },
        dataTable: {
            itemsPerPageText: '每页数目：',
            ariaLabel: {
                sortDescending: '：降序排列。',
                sortAscending: '：升序排列。',
                sortNone: '：未排序。',
                activateNone: '点击以移除排序。',
                activateDescending: '点击以降序排列。',
                activateAscending: '点击以升序排列。'
            },
            sortBy: '排序方式'
        },
        dataFooter: {
            itemsPerPageText: '每页数目：',
            itemsPerPageAll: '全部',
            nextPage: '下一页',
            prevPage: '上一页',
            firstPage: '首页',
            lastPage: '尾页',
            pageText: '{0}-{1} 共 {2}'
        },
        datePicker: {
            itemsSelected: '已选择 {0}',
            nextMonthAriaLabel: '下个月',
            nextYearAriaLabel: '明年',
            prevMonthAriaLabel: '前一个月',
            prevYearAriaLabel: '前一年'
        },
        noDataText: '没有数据',
        carousel: {
            prev: '上一张',
            next: '下一张',
            ariaLabel: {
                delimiter: '轮播图第 {0} 张，共 {1} 张'
            }
        },
        calendar: {
            moreEvents: '还有 {0} 项'
        },
        input: {
            clear: '清除 {0}',
            prependAction: '{0} 的前置操作',
            appendAction: '{0} 的后置操作'
        },
        fileInput: {
            counter: '{0} 个文件',
            counterSize: '{0} 个文件（共 {1}）'
        },
        timePicker: {
            am: 'AM',
            pm: 'PM'
        },
        pagination: {
            ariaLabel: {
                wrapper: '分页导航',
                next: '下一页',
                previous: '上一页',
                page: '转到页面 {0}',
                currentPage: '当前页 {0}'
            }
        },
        rating: {
            ariaLabel: {
                icon: '评分：{1} 分中的 {0} 分'
            }
        },
        loading: '加载中...'
    },
    DAYS_OF_WEEK: {
        SUN: "日",
        MON: "一",
        TUE: "二",
        WED: "三",
        THU: "四",
        FRI: "五",
        SAT: "六",
    },
    URL_INVALID: "URL 无效",
    SELECT_ROOM_TYPE: "选择房间类型",
    OTA_CONNECTION_ERROR: "OTA连接错误",
    ROOM_RATE_TYPE: "房型 {room} 价格计划 {rate}",
    NOT_MATCH_GUEST_COUNT: "ezCrs 和 Traveloka 之间的入住人数不匹配",
    STAFF_MANAGEMENT: "员工管理",
    FUNCTION_MANAGEMENT: "功能管理",
    SETUP_RATE_TYPE: "设置从渠道发送到CM的价格类型",
    INCLUDE_COMMISSION: "包含佣金",
    EXCLUDE_COMMISSION: "不包含佣金",
    UNDEFINED_COMMISSION: "未定义",
    EXTRA_DATA_TO_OTA: "设置从渠道发送到渠道管理系统的价格类型",
    ROOM_TYPE_SYNCED: "该房型已与OTA映射，请再次确认。",
    MANDATORY_LANGUAGE_REQUIRED: "必须选择越南语和英语。",
    TOOLTIP_TOGGLE_LANGUAGE: "更改显示语言时，请同时更新所有多语言字段，例如房型名称、政策名称等。",
    TOOLTIP_INCLUDE_COMMISSION: `
        <span class="font-weight-bold fs-13">-配置：不含佣金</span> —— 当渠道代收房费且系统具备足够数据时，ezCrs 将按规则重算房价。<br/>
        <span class="font-weight-bold fs-13">-配置：含佣金</span> —— ezCrs 将按渠道回传的房价原值入账，不再进行换算。<br/>
        <span class="font-weight-bold fs-13">-配置：未定义</span> —— 当系统无法判断渠道回传房价是否已含佣金时使用该选项。
        此时 <span class="font-weight-bold fs-13">含佣金</span> 与 <span class="font-weight-bold fs-13">不含佣金</span> 两项都会显示为 <span class="font-weight-bold fs-13">未定义</span>。`,
    TOOLTIP_INCLUDE_COMMISSION_AGODA: `
        <span class="font-weight-bold fs-13">-配置：含佣金</span> —— 当系统具备足够数据时，ezCrs 将按规则重算房价。<br/>
        <span class="font-weight-bold fs-13">-配置：不含佣金</span> —— ezCrs 将按渠道回传的房价原值入账，不再进行换算。<br/>
        <span class="font-weight-bold fs-13">-配置：未定义</span> —— 当系统无法判断渠道回传房价是否已含佣金时使用该选项。
        此时 <span class="font-weight-bold fs-13">含佣金</span> 与 <span class="font-weight-bold fs-13">不含佣金</span> 两项都会显示为 <span class="font-weight-bold fs-13">未定义</span>。`,
    INPUT_INVALID: "超出最大数量",
    GOOGLE_NOTE: "<strong>注意：</strong> 根据 Google 的最新规定，使用 Google Hotel 的酒店必须更新<strong>税费</strong>数据。为确保系统有效性并避免错误，必须至少包含<strong>一个大于 0 的税费项目</strong>。",
    INVOICE_REQUEST: "发票申请",
    COMPANY_NAME_OR_BOOKER: "公司名称/预订人",
    HIDE_INFORMATION: "（隐藏信息）",
    SHOW_INFORMATION: "（显示信息）",
    MODULE_EZ_PROMOTION_NOT_ACTIVE: "促销模块未启用",
    INCLUDE_COMMISSION_RATE: "包含佣金",
    EXCLUDE_COMMISSION_RATE: "不包含佣金",
    COMMISSION_RATE_NOTE: "注：包含和不包含佣金的数据仅供参考",
    SETUP_RATE_TYPE_NOTE: "注意：仅当系统中至少有一个（01）房型已成功连接至对应渠道时，方可修改“从渠道发送至CM的价格设置”配置。",
};